import React, { Component } from "react";
import { connect } from "react-redux";
import Header from "../../../../common_components/Header";
import Footer from "../../../../common_components/Footer";
import Drawer from "../../../../common_components/Drawer";
import {
  addVendorRegistration_action,
  updateVendorRegistration_action,
  getDetailsVendorRegistration_action,
} from "../../../../actions/admin_module_action/vendor_action/vendorRegistration_action/vendorRegistration_action";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { withRouter } from "../../../../utils/withRouter";
import moment from "moment";
import Modal from "react-modal";
import Loader from "../../../../utils/Loader";
import {
  exhibitionId,
  countryActionId,
  stateActionId,
  cityActionId,
  pincodeActionId,
  verifyPrimaryEmailIDActionId,
  toastError,
  toastSuccess,
  serviceTypeId,
  HallZoneListActionId,
  BASE_URL, hallMasterListActionId
} from "../../../../utils/constants";
import Pagination from "../../../../utils/pagination";
import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { fill_action } from "../../../../actions/fillCombo_action";
import Resizer from "react-image-file-resizer";
import {
  contactNoValidator,
  panNoValidator,
  tanNoValidator,
  gstNoValidator,
  emailValidator,
  pincodeValidator,
} from "../../../../utils/Validator";
import $ from "jquery";
import HeaderWithLogo from "../../../../common_components/header_with_logo";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ExhibitorHeader from "../../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../../common_components/exhibitor_module_topmenu";
import AdminDrawer from "../../../../common_components/admin_module_drawer";
import VendorDashboard from "../../../vendor_module/vendor_dashboard/vendor_dashboard";
import VendorDrawer from "../../../../common_components/vendor_module_drawer";
import ImageCapture from "../../../../utils/ImageCapture";
import {
  getAPDetails_action,
  insertUpdateAP_action,
  generateRevisedPI_action,
} from "../../../../actions/admin_module_action/exhibitor_list_action/exhibitor_list_action";
/*
 * mapDispatchToProps
 */
// const mapDispatchToProps = dispatch => ({
//     loginAction: () => dispatch(loginAction())
// })

/*
 * mapStateToProps
 */
const mapStateToProps = (state) => ({
  ...state,
});

class VendorRegistrationAU extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isCorrespondenceDetails: false,
      isFirstStepCompleted: false,
      is_update: false,
      isCountryIndia: false,
      showVideoModal: false,
      countryNamePre: "",
      countryNamePreRegisterMobileNo: "",
      countryNamePreRegisterAlternateMobileNo: "",
      countryNamePreOwnerMobileNo: "",
      countryNamePreInvoiceregisterMobileNo: "",
      countryNamePreInvoiceregisterAlternateMobileNo: "",

      isPrimaryEmailId: false,
      isSecondaryEmailId: false,
      isOwenerEmailId: false,

      isInvoiceprimaryEmailId: false,
      isInvoicesecondaryEmailId: false,

      registerTelephoneNoPre: "",
      registerTelephoneNo1Pre: "",

      invLastNamePersonIncharge: "",
      lastNamePersonIncharge: "",
      invLastNamePersonInchargeErr: "",
      lastNamePersonInchargeErr: "",

      invoiceregisterTelephoneNoPre: "",
      invoiceregisterTelephoneNo1Pre: "",

      formFileType: "",
      declarationFileType: "",
      trcFileType: "",
      isSelfPaid: false,

      hallList: [],
      countryList: [],
      stateList: [],
      cityList: [],
      pincodeList: [],
      tempStateList: [],
      tempCityList: [],
      tempPincodeList: [],
      _pincodeList: [],
      isEmailExist: false,

      InvtempStateList: [],
      InvtempCityList: [],
      InvtempPincodeList: [],

      formFile: "",
      declarationFile: "",
      trcFile: "",

      countryId: "",
      countryName: "",
      registerMobileNo: "",
      registerMobileNoErr: "",

      companyName: "",
      companyId: "",
      fasciaName: "",
      address1: "",
      address2: "",
      cityId: "",
      cityName: "",
      stateId: "",
      stateName: "",
      pinCode: "",
      inchargeFirstName: "",
      designation: "",
      registerAlternateMobileNo: "",
      registerTelephoneNo: "",
      registerTelephoneNo1: "",
      registerTelefaxNo: "",
      primaryEmailId: "",
      secondaryEmailId: "",
      website: "",
      nameOfOwner: "",
      lastName: "",
      ownerMobileNo: "",
      ownerEmailId: "",
      countryId: "",

      title_inchargeFirstName: "Mr",
      title_name_Of_CEO_MD_President_Owner: "Mr",
      title_InvPersonIncharge: "Mr",

      isOther_title_inchargeFirstName: false,
      isOther_title_name_Of_CEO_MD_President_Owner: false,
      isOther_title_InvPersonIncharge: false,

      other_title_inchargeFirstName: "",
      other_title_name_Of_CEO_MD_President_Owner: "",
      other_title_InvPersonIncharge: "",

      invoicecompanyName: "",
      invoicecompanyId: "",
      invoicefasciaName: "",
      invoiceaddress1: "",
      invoiceaddress2: "",
      invoicecityId: "",
      invoicecityName: "",
      invoicestateId: "",
      invoicestateName: "",
      invoicepinCode: "",
      invoiceinchargeFirstName: "",
      invoicedesignation: "",
      invoiceregisterMobileNo: "",
      invoiceregisterAlternateMobileNo: "",
      invoiceregisterTelephoneNo: "",
      invoiceregisterTelephoneNo1: "",
      invoiceregisterTelefaxNo: "",
      invoiceprimaryEmailId: "",
      invoicesecondaryEmailId: "",
      invoicewebsite: "",
      invoicenameOfOwner: "",
      invoicelastName: "",
      invoiceownerMobileNo: "",
      invoiceownerEmailId: "",
      invoicecountryName: "",
      invoicecountryid: "",
      compInfoNameOnPanCard: "",
      compInfoPanNo: "",
      compInfoTAN: "",
      compInfoGstNo: "",
      compInfoRegistrationNo: "",
      compInfoIecCode: "",

      bankDtlAccountName: "",
      bankDtlAccountNo: "",
      bankDtlAccountType: "",
      bankDtlAccountTypeOthers: "",
      bankDtlBankName: "",
      bankDtlBranchName: "",
      bankDtlIfscCode: "",

      // error state
      companyNameErr: "",
      fasciaNameErr: "",
      address1Err: "",
      address2Err: "",
      registerMobileNoErr: "",
      cityNameErr: "",
      stateNameErr: "",
      pinCodeErr: "",
      countryNameErr: "",

      inchargeFirstNameErr: "",
      designationErr: "",
      registerAlternateMobileNoErr: "",
      registerTelephoneNoErr: "",
      registerTelefaxNoErr: "",
      primaryEmailIdErr: "",
      secondaryEmailIdErr: "",
      websiteErr: "",
      nameOfOwnerErr: "",

      lastNameErr: "",
      ownerMobileNoErr: "",
      ownerEmailIdErr: "",

      invoicecompanyNameErr: "",
      invoicecompanyIdErr: 0,
      invoicefasciaNameErr: "",
      invoiceaddress1Err: "",
      invoiceaddress2Err: "",
      invoicecityIdErr: 0,
      invoicecityNameErr: "",
      invoicestateIdErr: 0,
      invoicestateNameErr: "",
      invoicepinCodeErr: "",
      invoicecountryNameErr: "",
      invoiceinchargeFirstNameErr: "",
      invoicedesignationErr: "",
      invoiceregisterMobileNoErr: "",
      invoiceregisterAlternateMobileNoErr: "",
      invoiceregisterTelephoneNoErr: "",
      invoiceregisterTelefaxNoErr: "",
      invoiceprimaryEmailIdErr: "",
      invoicesecondaryEmailIdErr: "",
      invoicewebsiteErr: "",
      invoicenameOfOwnerErr: "",
      invoicelastNameErr: "",
      invoiceownerMobileNoErr: "",
      invoiceownerEmailIdErr: "",
      countryNameErr: "",

      compInfoNameOnPanCardErr: "",
      compInfoPanNoErr: "",
      compInfoTANErr: "",
      compInfoGstNoErr: "",
      compInfoRegistrationNoErr: "",
      compInfoIecCodeErr: "",

      bankDtlAccountNameErr: "",
      bankDtlAccountNoErr: "",
      bankDtlAccountTypeErr: "",
      bankDtlAccountTypeOthersErr: "",
      bankDtlBankNameErr: "",
      bankDtlBranchNameErr: "",
      bankDtlIfscCodeErr: "",

      exhRegistrationID: 0,
      exhibitionID: 0,
      exhRegistrationNo: "",
      exhRegistrationDate: "",

      isDisplayCityList: false,
      isDisplayStateList: false,
      isDisplayPincodeList: false,

      isDisplayInvCityList: false,
      isDisplayInvStateList: false,
      isDisplayInvPincodeList: false,

      namePrefix: ["Mr", "Ms", "DR", "Prof"],

      add: false,
      update: false,
      serviceTypeId: "",
      serviceTypeList: [],
      renderServiceTypeList: [],
      password: "",
      passwordErr: "",
      IsItmeBilling: true,
      IsVendorBilling: false,
      Approval_Rights: 1,
      countryCode: "",
      exhibitionId: sessionStorage.getItem("sessionExhibitionID"),
      exhibitionList: [],
      serviceTypeErr: "",
      exhibitionErr: "",
      PreMobileNo: "",
      PreAlternateMobileNo: "",
      PreTelephoneNo: "",
      PreTelephoneNo1: "",
      preMobile: "",
      HallZoneList: [],
      renderHallZoneList: [],
      EmpanelmentFee: "",
      AccountType: "",
      YearOfEstablishment: "",
      NoOfStaff: "",
      NoOfEventHandled: "",
      ShortDescription: "",
      isVendor: JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 7 || JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 17,
      USP: "",
      ClientEventList: "",
      YearOfEstablishmentErr: "",
      NoOfStaffErr: "",
      NoOfEventHandledErr: "",
      ShortDescriptionErr: "",
      USPErr: "",
      ClientEventListErr: "",
      isHallManager: false,
      isWorkUpdation: this.props.location.pathname == "/vendorAndScopofwork",
      showDDDetails: false,
      isImageModal: false,
      DD_FileName: null,
      DD_FilePath: null,
      DD_FileType: null,
      DD_SubContractorList: [],
      DD_Number: "",
      DD_Amount: "",
      DD_Date: null,
      DD_BankName: "",
      DD_SubmittedBy_CompanyName: "",
      DD_SubmittedBy_PersonName: "",
      DD_SubmittedBy_MobileNo: "",
      DD_SubmittedBy_EmailId: "",
      DD_ReturnTo_CompanyName: "",
      DD_ReturnTo_PersonName: "",
      DD_ReturnTo_MobileNo: "",
      DD_ReturnTo_EmailId: "",
      DD_SameAsAbove: false,
      VendorID: 0,
      isOpen2: false,
    };
    this.getFillList = this.getFillList.bind(this);
    this.inputValidate = this.inputValidate.bind(this);
  }

  onSelectCityId(e) {
    e.preventDefault();
    const { cityId, cityList, cityName } = this.state;

    let cityData = cityList.filter((x) => x.Code == e.target.value)[0];
    this.setState({ cityId: cityData.Code, cityName: cityData.Description });

    this.getFillList(pincodeActionId, "", "", cityData.Code, "", "");

    // cityList.map(data => {
    //     data.Code == cityName && this.setState({ cityId: data.Code, cityName: data.Description , cityNameErr:''})
    // });
  }

  onSelectStateId(e) {
    e.preventDefault();
    const {
      stateId,
      stateList,
      stateName,
      _pincodeList,
      pincodeList,
      cityName,
    } = this.state;

    stateList.map((data) => {
      data.Code == stateName &&
        this.setState({
          stateId: data.Code,
          stateName: data.Description,
          stateNameErr: "",
          _pincodeList: pincodeList.filter(
            (x) => x.StateName == stateName && x.CityName == cityName
          ),
        });
    });
  }

  onSelectPincodeId(e) {
    e.preventDefault();
    const { pincodeId, pincodeList, pinCode } = this.state;
    pincodeList.map((data) => {
      data.Code == pinCode &&
        this.setState({
          pincodeId: data.Code,
          pinCode: data.Description,
          pinCodeErr: "",
        });
    });
  }
  onFilePick = async (e, file) => {
    e.preventDefault();
    if (file[0]["size"] > 5242880) {
      toast.error("File size more than 5mb are not allow.", {
        theme: "colored",
        autoClose: 3000,
        hideProgressBar: true,
      });
      e.target.value = "";
      return;
    }

    if (
      file[0]["name"].toString().toLowerCase().includes(".pdf") ||
      file[0]["name"].toString().toLowerCase().includes(".jpeg") ||
      file[0]["name"].toString().toLowerCase().includes(".png") ||
      file[0]["name"].toString().toLowerCase().includes(".jpg")
    ) {
      const image = await this.convertToBase64(file[0]);
      this.setState({
        DD_FilePath: image,
        DD_FileName: file[0]["name"],
        DD_FileType: file[0]["name"].split(".")[1],
      });
    } else {
      toast.error(
        "Allowed File types .jpg,.jpeg,.png,.pdf with maximum size 5 MB",
        {
          theme: "colored",
          autoClose: 3000,
          hideProgressBar: true,
        }
      );
      e.target.value = "";
    }
  };

  convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  // Fill empty mobile ISD codes from the selected country (when details load before the country list)
  fillIsdCodes = () => {
    const { countryList, countryName, PreMobileNo, PreAlternateMobileNo, preMobile } = this.state;
    const country = (countryList || []).find((c) => c.Code == countryName);
    if (!country || country.CountryCode == null) return;
    const keep = (value) => (value != null && value !== "" ? value : country.CountryCode);
    this.setState({
      PreMobileNo: keep(PreMobileNo),
      PreAlternateMobileNo: keep(PreAlternateMobileNo),
      preMobile: keep(preMobile),
    });
  };

  // Display an ISD code with a leading "+" (state keeps the code as stored)
  formatIsd = (code) => {
    if (code == null || code === "") return "";
    const text = code.toString().trim();
    return text.startsWith("+") ? text : `+${text}`;
  };

  handleViewFile = (base64String, fileName) => {
    const mimeType = base64String.split(";")[0].split(":")[1];
    const byteCharacters = atob(base64String.split(",")[1]);
    const byteNumbers = Array.from(byteCharacters).map((char) =>
      char.charCodeAt(0)
    );
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mimeType });
    const fileURL = URL.createObjectURL(blob);

    if (mimeType.startsWith("image/") || mimeType === "application/pdf") {
      const newTab = window.open(fileURL, "_blank", "noopener,noreferrer");
      if (newTab) {
        newTab.document.title = fileName;
      }
    } else {
      const link = document.createElement("a");
      link.href = fileURL;
      link.download = fileName;
      link.click();
    }
    setTimeout(() => URL.revokeObjectURL(fileURL), 500);
  };
  async componentDidMount() {
    console.log("this.props", this.props);
    await this.getFillList(
      countryActionId,
      sessionStorage.getItem("sessionExhibitionID"),
      "",
      "",
      "",
      ""
    );
    await this.getFillList(
      cityActionId,
      sessionStorage.getItem("sessionExhibitionID"),
      "",
      "",
      "",
      ""
    );
    await this.getFillList(
      stateActionId,
      sessionStorage.getItem("sessionExhibitionID"),
      "",
      "",
      "",
      ""
    );
    await this.getFillList(
      pincodeActionId,
      sessionStorage.getItem("sessionExhibitionID"),
      "",
      "",
      "",
      ""
    );
    await this.getFillList(
      serviceTypeId,
      sessionStorage.getItem("sessionExhibitionID"),
      "",
      "",
      "",
      ""
    );
    await this.getFillList(
      exhibitionId,
      sessionStorage.getItem("sessionExhibitionID"),
      "",
      "",
      "",
      ""
    );
    await this.getFillList(
      hallMasterListActionId,
      sessionStorage.getItem("sessionExhibitionID"),
      "",
      "",
      "",
      ""
    );

    // console.log("7879", this.props.location.state.countryId)

    this.setState({
      add:
        this.props.location.state != null &&
          this.props.location.state.add != null
          ? this.props.location.state.add
          : null,
      update:
        this.props.location.state != null &&
          this.props.location.state.update != null
          ? this.props.location.state.update
          : null,
      AccountType:
        this.props.location.state != null &&
          this.props.location.state.AccountType != null
          ? this.props.location.state.AccountType
          : null,
      isHallManager:
        this.props.location.state != null &&
          this.props.location.state.isHallManager != null
          ? this.props.location.state.isHallManager
          : false,
    });

    if (
      (this.props.location.state != null &&
        this.props.location.state.update != null &&
        this.props.location.state.update) ||
      this.state.isVendor
    ) {
      this.detailsVendorRegistration();
    } else {
      this.getFillList(
        HallZoneListActionId,
        sessionStorage.getItem("sessionExhibitionID"),
        "",
        "",
        "",
        ""
      );
    }

    const focusSection = sessionStorage.getItem("focusSection");
    if (focusSection === "companyProfile") {
      setTimeout(() => {
        const element = document.getElementById("companyProfileSection");
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
        sessionStorage.removeItem("focusSection");
      }, 500);
    }
  }

  loadscript() {
    $(document).ready(function () {
      $(this).scrollTop(0);
    });
  }

  // render city
  renderCityList() {
    const { cityList, cityName, tempCityList } = this.state;
    return (
      <ul
        className="list-group pincode-drop shadow rounded"
        style={{ position: "absolute", zIndex: 1, cursor: "pointer" }}
      >
        {tempCityList.length > 0 &&
          tempCityList.map((data) => (
            <li
              class="list-group-item"
              key={Math.random()}
              onClick={(e) =>
                this.setState({
                  cityName: data.Description.split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(" "),
                  isDisplayCityList: false,
                })
              }
            >
              {data.Description.split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(" ")}
            </li>
          ))}
      </ul>
    );
  }
  // searcg city
  onCitySearch(e) {
    const { cityList, cityName, tempCityList, countryName } = this.state;
    if (e.target.value != "") {
      this.setState({ cityNameErr: "" });
      if (countryName == 91 || countryName == "select" || countryName == "") {
        var searchCityList = tempCityList.filter((data) => {
          return data.Description.toLowerCase().includes(
            e.target.value.toLowerCase()
          );
        });
        this.setState({
          cityName: e.target.value
            .replace(/[^a-zA-Z ]/g, "")
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(" "),
          cityNameErr: "",
          tempCityList: searchCityList,
          isDisplayCityList: true,
        });
        // call state fill list pass city id
        //this.getFillList(stateActionId,"","",)
      } else {
        this.setState({
          cityName: e.target.value
            .replace(/[^a-zA-Z ]/g, "")
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(" "),
          isDisplayCityList: false,
        });
      }
    } else {
      this.setState({
        cityName: "",
        tempCityList: cityList,
        isDisplayCityList: false,
      });
    }
  }
  // state list
  callStateList(value) {
    const { stateList, stateName, tempStateList } = this.state;
    this.setState({ stateName: value.split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(" "), isDisplayStateList: false });
    this.getFillList(stateActionId, "", "", "", stateName, "", "");
  }

  // render state
  renderStateList() {
    const { stateList, stateName, tempStateList } = this.state;
    return (
      <ul
        className="list-group pincode-drop shadow rounded"
        style={{ position: "absolute", zIndex: 1, cursor: "pointer" }}
      >
        {tempStateList.length > 0 &&
          tempStateList.map((data) => (
            <li
              class="list-group-item"
              key={Math.random()}
              onClick={(e) => this.callStateList(data.Description)}
            >
              {data.Description.split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(" ")}
            </li>
          ))}
      </ul>
    );
  }
  // search state
  onStateSearch(e) {
    const { stateList, stateName, tempStateList, countryName } = this.state;
    console.log("onStateSearch");
    if (e.target.value != "") {
      this.setState({ stateNameErr: "" });
      if (countryName == 91 || countryName == "select" || countryName == "") {
        var searchStateList = tempStateList.filter((data) => {
          return data.Description.toLowerCase().includes(
            e.target.value.toLowerCase()
          );
        });
        this.setState({
          stateName: e.target.value
            .replace(/[^a-zA-Z ]/g, "")
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(" "),
          stateNameErr: "",
          tempStateList: searchStateList,
          isDisplayStateList: true,
        });
        // call pincode fill list pass city id and state id
        // this.getFillList(pincodeActionId, '', '', '', stateName, '')
      } else {
        this.setState({
          stateName: e.target.value
            .replace(/[^a-zA-Z ]/g, "")
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(" "),
          isDisplayStateList: false,
        });
      }
    } else {
      this.setState({
        stateName: "",
        tempStateList: stateList,
        isDisplayStateList: false,
      });
    }
  }

  // render pincode
  renderPincodeList() {
    const { pincodeList, pinCode, tempPincodeList } = this.state;
    return (
      <ul
        className="list-group pincode-drop shadow rounded"
        style={{ position: "absolute", zIndex: 1, cursor: "pointer" }}
      >
        {tempPincodeList.length > 0 &&
          tempPincodeList.map((data) => (
            <li
              class="list-group-item"
              key={Math.random()}
              onClick={(e) =>
                this.setState({
                  pinCode: data.Pincode,
                  isDisplayPincodeList: false,
                })
              }
            >
              {data.Pincode}
            </li>
          ))}
      </ul>
    );
  }
  // search pincode
  onPincodeSearch(e) {
    const { pincodeList, pinCode, tempPincodeList, countryName } = this.state;
    if (e.target.value != "") {
      this.setState({ pinCodeErr: "" });
      if (countryName == 91 || countryName == "select" || countryName == "") {
        var searchPincodeList = tempPincodeList.filter((data) => {
          return data.Pincode.toLowerCase().includes(
            e.target.value.toLowerCase()
          );
        });
        console.log("onPincodeSearch 123", countryName);
        // console.log('pincodeCount', searchPincodeList.length)
        this.setState({
          tempPincodeList: searchPincodeList,
          pinCode: e.target.value.replace(/\D/, ""),
          pinCodeErr: "",
          isDisplayPincodeList: true,
        });
      } else {
        this.setState({
          pinCode: e.target.value.replace(/\D/, ""),
          isDisplayPincodeList: false,
        });
      }
    } else {
      this.setState({
        pinCode: "",
        tempPincodeList: pincodeList,
        isDisplayPincodeList: false,
      });
    }
  }

  inputValidate() {
    const {
      countryId,
      countryName,
      registerMobileNo,
      registerMobileNoErr,
      countryNamePre,
      companyName,
      companyId,
      fasciaName,
      address1,
      address2,
      cityId,
      cityName,
      stateId,
      stateName,
      pinCode,
      inchargeFirstName,
      designation,
      registerAlternateMobileNo,
      registerTelephoneNo,
      registerTelephoneNo1,
      registerTelefaxNo,
      primaryEmailId,
      secondaryEmailId,
      website,
      nameOfOwner,
      lastName,
      ownerMobileNo,
      ownerEmailId,
      password,

      compInfoNameOnPanCard,
      compInfoPanNo,
      compInfoTAN,
      compInfoGstNo,
      compInfoRegistrationNo,
      compInfoIecCode,
      bankDtlAccountName,
      bankDtlAccountNo,
      bankDtlAccountType,
      bankDtlBankName,
      bankDtlBranchName,
      bankDtlIfscCode,

      compInfoNameOnPanCardErr,
      isCountryIndia,
      invLastNamePersonIncharge,
      lastNamePersonIncharge,
      invLastNamePersonInchargeErr,
      lastNamePersonInchargeErr,
      serviceTypeId,
      exhibitionId,
      bankDtlAccountTypeOthers,
      renderServiceTypeList,
      YearOfEstablishment,
      NoOfStaff,
      NoOfEventHandled,
      ShortDescription,
      USP,
      ClientEventList,
      isVendor,
      showDDDetails,
      DD_Number,
      DD_Amount,
      DD_Date,
      DD_BankName,
      DD_SubmittedBy_CompanyName,
      DD_SubmittedBy_PersonName,
      DD_SubmittedBy_MobileNo,
      DD_SubmittedBy_EmailId,
      DD_ReturnTo_CompanyName,
      DD_ReturnTo_PersonName,
      DD_ReturnTo_MobileNo,
      DD_ReturnTo_EmailId,
      DD_FileName,
    } = this.state;

    if (
      exhibitionId == "" ||
      exhibitionId == "Select" ||
      exhibitionId == null
    ) {
      this.setState({
        exhibitionErr: "Please select exhibition",
      });
    }

    if (renderServiceTypeList == "") {
      this.setState({
        serviceTypeErr: "Please select service type",
      });
    }

    if (lastNamePersonIncharge == "") {
      this.setState({
        lastNamePersonInchargeErr: "Please enter person incharge last name",
      });
    }

    if (invLastNamePersonIncharge == "") {
      this.setState({
        invLastNamePersonInchargeErr: "Please enter person incharge last name",
      });
    }

    if (companyName == "") {
      this.setState({
        companyNameErr: "Please enter company name",
      });
    }
    // YearOfEstablishmentErr: '',
    // NoOfStaffErr: '',
    // NoOfEventHandledErr: '',
    // ShortDescriptionErr: '',
    // USPErr: '',
    // ClientEventListErr: '',
    if (isVendor) {
      if (!YearOfEstablishment || YearOfEstablishment === "") {
        this.setState({
          YearOfEstablishmentErr: "Please enter year of establishment",
        });
      }
      if (!NoOfStaff || NoOfStaff === "") {
        this.setState({ NoOfStaffErr: "Please enter no of staff" });
      }

      if (!NoOfEventHandled || NoOfEventHandled === "") {
        this.setState({
          NoOfEventHandledErr: "Please enter no of event handled",
        });
      }

      if (!ShortDescription || ShortDescription === "") {
        this.setState({
          ShortDescriptionErr: "Please enter short description",
        });
      }

      if (!USP || USP === "") {
        this.setState({ USPErr: "Please enter USP" });
      }

      if (!ClientEventList || ClientEventList === "") {
        this.setState({
          ClientEventListErr: "Please enter Client list / event list",
        });
      }
    }

    if (showDDDetails) {
      if (!DD_Number || DD_Number === "") {
        toastError("Please enter DD Number");
      }
      if (!DD_Amount || DD_Amount === "") {
        toastError("Please enter DD Amount");
      }
      if (!DD_Date) {
        toastError("Please select DD Date");
      }
      if (!DD_BankName || DD_BankName === "") {
        toastError("Please enter Bank Name");
      }
      if (!DD_SubmittedBy_CompanyName || DD_SubmittedBy_CompanyName === "") {
        toastError("Please enter DD Submitted By Company Name");
      }
      if (!DD_SubmittedBy_PersonName || DD_SubmittedBy_PersonName === "") {
        toastError("Please enter DD Submitted By Person Name");
      }
      if (!DD_SubmittedBy_MobileNo || DD_SubmittedBy_MobileNo === "") {
        toastError("Please enter DD Submitted By Mobile No");
      }
      if (!DD_SubmittedBy_EmailId || DD_SubmittedBy_EmailId === "") {
        toastError("Please enter DD Submitted By Email Id");
      }
      if (!DD_ReturnTo_CompanyName || DD_ReturnTo_CompanyName === "") {
        toastError("Please enter DD Return To Company Name");
      }
      if (!DD_ReturnTo_PersonName || DD_ReturnTo_PersonName === "") {
        toastError("Please enter DD Return To Person Name");
      }
      if (!DD_ReturnTo_MobileNo || DD_ReturnTo_MobileNo === "") {
        toastError("Please enter DD Return To Mobile No");
      }
      if (!DD_ReturnTo_EmailId || DD_ReturnTo_EmailId === "") {
        toastError("Please enter DD Return To Email Id");
      }
      if (!DD_FileName) {
        toastError("Please upload DD Document");
      }
    }

    // if (fasciaName == '') {
    //     this.setState({
    //         fasciaNameErr: 'Please enter fascia name'
    //     })
    // }
    // if (address1 == '') {
    //     this.setState({
    //         address1Err: 'Please enter address'
    //     })
    // }

    if (registerMobileNo == "") {
      this.setState({
        registerMobileNoErr: "Please enter mobile number",
      });
    }

    // if (cityName == '') {
    //     this.setState({
    //         cityNameErr: 'Please enter city'
    //     })
    // }

    // if (stateName == '' && (countryName == '' || countryName == 'Select' || countryName == 91)) {
    //     this.setState({
    //         stateNameErr: 'Please enter state'
    //     })
    // }

    // if (password == '') {
    //     this.setState({
    //         passwordErr: 'Please enter password'
    //     })
    // }

    // if (pinCode == '') {
    //     this.setState({
    //         pinCodeErr: 'Please enter pincode'
    //     })
    // }

    if (countryName == "" || countryName == "Select") {
      this.setState({
        countryNameErr: "Please select country",
      });
    }
    if (inchargeFirstName == "") {
      this.setState({
        inchargeFirstNameErr: "Please enter person incharge first name",
      });
    }
    // if (designation == '') {
    //     this.setState({
    //         designationErr: 'Please enter designation'
    //     })
    // }
    if (primaryEmailId == "") {
      this.setState({
        primaryEmailIdErr: "Please enter primary email",
      });
    }
    // if (nameOfOwner == '') {
    //     this.setState({
    //         nameOfOwnerErr: 'Please enter name of owner'
    //     })
    // }
    // if (ownerEmailId == '') {
    //     this.setState({
    //         ownerEmailIdErr: 'Please enter email'
    //     })
    // }

    // not reuire below
    // // account details
    // if (bankDtlAccountName == '') {
    //     this.setState({
    //         bankDtlAccountNameErr: 'Please enter account name'
    //     })
    // }
    // if (bankDtlAccountNo == '') {
    //     this.setState({
    //         bankDtlAccountNoErr: 'Please enter account number'
    //     })
    // }
    // if (bankDtlIfscCode == '') {
    //     this.setState({
    //         bankDtlIfscCodeErr: 'Please enter IFSC Code'
    //     })
    // }
    // if (bankDtlAccountType == '' || bankDtlAccountType == 'Select') {
    //     this.setState({
    //         bankDtlAccountTypeErr: 'Please select account type'
    //     })
    // }
    // if (bankDtlAccountType == 'Others') {
    //     console.log("bankDtlAccountTypeOthers", bankDtlAccountTypeOthers)
    //     if (bankDtlAccountTypeOthers == '') {
    //         this.setState({
    //             bankDtlAccountTypeOthersErr: 'Please enter account type'
    //         })
    //     }
    // }

    // if (countryName == '' || countryName == 'Select' || countryName == 91) {
    //     if (compInfoNameOnPanCard == '' || compInfoNameOnPanCard == null) {
    //         this.setState({
    //             compInfoNameOnPanCardErr: 'Please enter name on pan card'
    //         })
    //     }
    //     if (compInfoPanNo == '' || compInfoPanNo == null) {
    //         this.setState({
    //             compInfoPanNoErr: 'Please enter pan no'
    //         })
    //     }
    //     if (compInfoTAN == '' || compInfoTAN == null) {
    //         this.setState({
    //             compInfoTANErr: 'Please enter tan no'
    //         })
    //     }
    //     if (compInfoGstNo == '' || compInfoGstNo == null) {
    //         this.setState({
    //             compInfoGstNoErr: 'Please enter gst no'
    //         })
    //     }
    // }
  }

  maxLengthCheck = (object, maxLength) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };

  onlyNumbers = (event) => {
    var charCode = event.which ? event.which : event.keyCode;
    if (charCode >= 48 && charCode <= 57) return true;
    return false;
  };

  // get fill List dropdown
  async getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
    this.setState({ isLoading: true });

    try {
      const data = await this.props.fill_action(
        actionID,
        exhibitionID,
        moduleID,
        keyValue,
        value
      );

      if (data.error === 1) {
        toastError(data.msg);
        return []; // safe fallback
      }

      // ---------------- country list ----------------
      if (actionID === countryActionId) {
        this.setState({ countryList: data.data }, () => this.fillIsdCodes());
        return data.data;
      }

      // ---------------- state list ----------------
      if (actionID === stateActionId) {
        this.setState({
          stateList: data.data,
          tempStateList: data.data,
          InvtempStateList: data.data,
        });
        return data.data;
      }

      if (actionID === hallMasterListActionId) {
        this.setState({
          hallList: data.data,
          // tempStateList: data.data,
          // InvtempStateList: data.data,
        });
        return data.data;
      }

      // ---------------- city list ----------------
      if (actionID === cityActionId) {
        this.setState({
          cityList: data.data,
          tempCityList: data.data,
          InvtempCityList: data.data,
        });
        return data.data;
      }

      // ---------------- pincode ----------------
      if (actionID === pincodeActionId) {
        this.setState({
          pincodeList: data.data,
          tempPincodeList: data.data,
          InvtempPincodeList: data.data,
        });
        return data.data;
      }

      // ---------------- service type ----------------
      if (actionID === serviceTypeId) {
        this.setState({ serviceTypeList: data.data });
        return data.data;
      }

      // ---------------- exhibition ----------------
      if (actionID === exhibitionId) {
        this.setState({ exhibitionList: data.data });
        return data.data;
      }

      // ---------------- hall/zone ----------------
      if (actionID === HallZoneListActionId) {
        const HallZoneList = Object.values(
          data.data.reduce((acc, { HallId, HallName, Zone, ZoneID }) => {
            if (!acc[HallId]) {
              acc[HallId] = {
                HallId,
                HallName,
                All: true,
                Specific: false,
                isHallChecked: false,
                zonelist: [],
              };
            }
            acc[HallId].zonelist.push({
              Zone,
              ZoneID,
              isZoneCheked: true,
            });
            return acc;
          }, {})
        );

        this.setState({ HallZoneList });
        return HallZoneList; // ✅ properly returned
      }

      return []; // default return if nothing matches
    } catch (e) {
      console.error(e);
      toastError("Something went wrong!");
      return [];
    } finally {
      this.setState({ isLoading: false });
    }
  }

  validateNumberField = (myNumber) => {
    const numberRegEx = /\-?\d*\.?\d{1,2}/;
    return numberRegEx.test(String(myNumber).toLowerCase());
  };

  changeUrl = (e) => {
    const { value } = e.target;
    const isValid = !value;
    console.log("isValid", isValid);
    this.setState({ pinCode: e.target.value, pinCodeErr: "" });
  };

  onCountry(e) {
    const {
      InvtempPincodeList,
      InvtempStateList,
      InvtempCityList,
      countryList,
    } = this.state;
    this.setState({ countryName: e.target.value, countryNameErr: "" });
    console.log("e.target.value", e.target.value);
    if (e.target.value != "") {
      if (e.target.value != 91) {
        this.setState({
          address1: "",
          address2: "",
          pinCode: "",
          stateName: "",
          cityName: "",
          pincodeList: [],
          cityList: [],
          stateList: [],
          InvtempPincodeList: [],
          InvtempStateList: [],
          InvtempCityList: [],
          isDisplayCityList: false,
          isDisplayStateList: false,
          isDisplayPincodeList: false,
          isDisplayInvCityList: false,
          isDisplayInvStateList: false,
          isDisplayInvPincodeList: false,
          // compInfoNameOnPanCard: '',
          // compInfoPanNo: '',
          // compInfoTAN: '',
          // compInfoGstNo: ''
        });
      } else {
        this.setState({
          address1: "",
          address2: "",
          pinCode: "",
          stateName: "",
          cityName: "",
        });
      }

      countryList.map((data) => {
        if (data.Code == e.target.value) {
          this.setState({
            preMobile: data.CountryCode,
            PreMobileNo: data.CountryCode,
            PreAlternateMobileNo: data.CountryCode,
          });
        }
      });
    } else {
      this.getFillList(
        cityActionId,
        sessionStorage.getItem("sessionExhibitionID"),
        "",
        e.target.value,
        "",
        ""
      );
      this.getFillList(
        stateActionId,
        sessionStorage.getItem("sessionExhibitionID"),
        "",
        e.target.value,
        "",
        ""
      );
      this.getFillList(
        pincodeActionId,
        sessionStorage.getItem("sessionExhibitionID"),
        "",
        "",
        "",
        ""
      );
      // this.setState({
      //     compInfoNameOnPanCard: '',
      //     compInfoPanNo: '',
      //     compInfoTAN: '',
      //     compInfoGstNo: ''
      // })
    }

    // countryList.map((data) => {
    //     if (data.Code == e.target.value) {
    //         this.setState({
    //             countryCode: data.CountryCode
    //         })
    //     }
    // })
  }

  onServiceType(e) {
    const {
      serviceTypeList,
      renderServiceTypeList,
      renderHallZoneList,
      HallZoneList,
    } = this.state;
    this.setState({ serviceTypeId: e.target.value, serviceTypeErr: "" });
    const value = e.target.value;
    if (value != "" && value != "Select") {
      const checkedId = renderServiceTypeList.some(
        (item) => item.ServiceID == value
      );
      if (!checkedId) {
        serviceTypeList.map((item) => {
          if (e.target.value == item.ServiceID) {
            renderServiceTypeList.push(item);
            renderHallZoneList.push({
              ...item,
              HallZoneList: HallZoneList,
              isAllHallChecked: false,
            });
            console.log("renderHallZoneList-->", renderHallZoneList);
            setTimeout(() => {
              this.setState({ serviceTypeId: "" });
            }, 500);
          }
        });
      } else {
        toastError("Service type already exits");
        setTimeout(() => {
          this.setState({ serviceTypeId: "" });
        }, 500);
      }
    }
  }

  deleteServiceType(id) {
    const { renderServiceTypeList, renderHallZoneList } = this.state;

    console.log("renderHallZoneList", renderHallZoneList);
    console.log(" id", id);

    const array = renderServiceTypeList.filter((item) => item.ServiceID != id);
    const array2 = renderHallZoneList.filter((item) => item.ServiceID != id);

    this.setState({ renderServiceTypeList: array, renderHallZoneList: array2 });

    toastSuccess(" Service deleted successfully");
  }

  async detailsVendorRegistration() {
    const id =
      (this.props.location.state && this.props.location.state.UserId) ||
      JSON.parse(sessionStorage.getItem("loginDataSS")).UserID;
    this.setState({ isLoading: true });
    this.props
      .getDetailsVendorRegistration_action(id)
      .then(async (data) => {
        if (data.error != 1) {
          this.setState({
            isLoading: false,
            IsItmeBilling: data.data["data"][0]["IsItmeBilling"],
            IsVendorBilling: data.data["data"][0]["IsVendorBilling"],
            Approval_Rights: data.data["data"][0]["IsApprovalRights"],
            companyName: data.data["data"][0]["CompanyName"],
            password: data.data["data"][0]["Password"],
            countryName: data.data["data"][0]["CountryID"],
            stateName: data.data["data"][0]["State"],
            cityName: data.data["data"][0]["City"],
            pinCode: data.data["data"][0]["Pin"],
            address1: data.data["data"][0]["Address1"],
            address2: data.data["data"][0]["Address2"],
            title_inchargeFirstName:
              data.data["data"][0]["Title_PersonIncharge"],
            inchargeFirstName: data.data["data"][0]["FirstName"],
            lastNamePersonIncharge:
              data.data["data"][0]["LastNamePersonIncharge"],
            designation: data.data["data"][0]["Designation"],
            registerTelefaxNo: data.data["data"][0]["TeleFax"],
            primaryEmailId: data.data["data"][0]["PrimaryEmail"],
            secondaryEmailId: data.data["data"][0]["SecondaryEmail"],
            website: data.data["data"][0]["Website"],
            title_name_Of_CEO_MD_President_Owner:
              data.data["data"][0]["Title_Name_Of_CEO_MD_President_Owner"],
            nameOfOwner: data.data["data"][0]["Name_Of_CEO_MD_President_Owner"],
            lastName: data.data["data"][0]["LastName"],
            ownerMobileNo: data.data["data"][0]["Mobile"],
            ownerEmailId: data.data["data"][0]["Email"],
            compInfoNameOnPanCard: data.data["data"][0]["NameOnPanCard"],
            compInfoPanNo: data.data["data"][0]["PanNo"],
            compInfoTAN: data.data["data"][0]["Tan"],
            compInfoGstNo: data.data["data"][0]["GSTNo"],
            compInfoRegistrationNo:
              data.data["data"][0]["CompanyRegistrationNo"],
            compInfoIecCode: data.data["data"][0]["IECCode"],
            bankDtlAccountName: data.data["data"][0]["AccountName"],
            bankDtlAccountNo: data.data["data"][0]["AccountNo"],
            bankDtlBankName: data.data["data"][0]["BankName"],
            bankDtlBranchName: data.data["data"][0]["BranchName"],
            bankDtlIfscCode: data.data["data"][0]["SwiftCode_IFSCCode"],
            EmpanelmentFee: data.data["data"][0]["EmpanelmentFee"],
            YearOfEstablishment: data.data["data"][0]["YearOfEstablishment"],
            NoOfStaff: data.data["data"][0]["NoOfStaff"],
            NoOfEventHandled: data.data["data"][0]["NoOfEventHandled"],
            ShortDescription: data.data["data"][0]["ShortDescription"],
            USP: data.data["data"][0]["USP"],
            ClientEventList: data.data["data"][0]["ClientEventList"],
            exhibitionId:
              data.data["HallZoneList"].length > 0
                ? data.data["HallZoneList"][0]["ExhibitionID"]
                : this.state.exhibitionId,
          });

          // Set VendorID from data response
          const vendorID =
            data.data["data"][0]["VendorID"] ||
            (data.data["DDDetails"] && data.data["DDDetails"].length > 0
              ? data.data["DDDetails"][0]["VendorID"]
              : 0);

          console.log("Setting VendorID:", vendorID);
          this.setState({ VendorID: vendorID });

          // Populate DD Details if available
          if (data.data["DDDetails"] && data.data["DDDetails"].length > 0) {
            const ddData = data.data["DDDetails"][0];
            const subcontractors = data.data["subcontractorDetails"] || [];

            this.setState({
              showDDDetails: true,
              DD_Number: ddData.DD_Number || "",
              DD_Amount: ddData.DD_Amount || "",
              DD_Date: ddData.DD_Date ? new Date(ddData.DD_Date) : null,
              DD_BankName: ddData.BankName || "",
              DD_SubmittedBy_CompanyName: ddData.DDSubmittedByCompanyName || "",
              DD_SubmittedBy_PersonName: ddData.DDSubmittedByPersonName || "",
              DD_SubmittedBy_MobileNo: ddData.DDSubmittedByMobileNo || "",
              DD_SubmittedBy_EmailId: ddData.DDSubmittedByEmaiID || "",
              DD_ReturnTo_CompanyName: ddData.DDReturnToCompanyName || "",
              DD_ReturnTo_PersonName: ddData.DDReturnToPersonName || "",
              DD_ReturnTo_MobileNo: ddData.DDReturnToMobileNo || "",
              DD_ReturnTo_EmailId: ddData.DDReturnToEmaiID || "",
              DD_FileName: ddData.DDReturnToPhotoID
                ? ddData.DDReturnToPhotoID.split("/").pop()
                : null,
              DD_FilePath: ddData.DDReturnToPhotoID || null,
              DD_FileType: ddData.DDReturnToPhotoID
                ? ddData.DDReturnToPhotoID.split(".").pop()
                : null,
              DD_SameAsAbove: ddData.IsSameAsAbove || false,
              DD_SubContractorList: subcontractors.map((sub) => ({
                CompanyName: sub.SubContractorCompanyName || "",
                PersonName: sub.SubContractorPersonName || "",
                EmailId: sub.SubcontractorEmailID || "",
                MobileNo: sub.SubContractorMobileNo || "",
              })),
            });
          }

          // Split saved "code-number" values; without "-" the whole value is the number.
          // Mobiles then take the country's ISD code, telephones leave STD empty.
          const savedCountry = (this.state.countryList || []).find(c => c.Code == data.data["data"][0]["CountryID"])
          const countryIsd = savedCountry && savedCountry.CountryCode != null ? savedCountry.CountryCode : ""
          const splitPhone = (value, defaultCode) => {
            if (value == null) return null
            const text = value.toString().trim()
            const index = text.indexOf("-")
            return index === -1 ? [defaultCode, text] : [text.slice(0, index), text.slice(index + 1)]
          }
          const MobileNo = splitPhone(data.data["data"][0]["MobileNo"], countryIsd);
          const AlternateMobileNo = splitPhone(data.data["data"][0]["AlternateMobileNo"], countryIsd);
          const Telephone = splitPhone(data.data["data"][0]["Telephone"], "");
          const Telephone1 = splitPhone(data.data["data"][0]["Telephone1"], "");
          const Mobile = splitPhone(data.data["data"][0]["Mobile"], countryIsd);

          this.setState({
            registerMobileNo: MobileNo != null ? MobileNo[1] : null,
            registerAlternateMobileNo:
              AlternateMobileNo != null ? AlternateMobileNo[1] : null,
            registerTelephoneNo: Telephone != null ? Telephone[1] : null,
            registerTelephoneNo1: Telephone1 != null ? Telephone1[1] : null,
            ownerMobileNo: Mobile != null ? Mobile[1] : null,
            preMobile: Mobile != null ? Mobile[0] : null,
            PreMobileNo: MobileNo != null ? MobileNo[0] : null,
            PreAlternateMobileNo:
              AlternateMobileNo != null ? AlternateMobileNo[0] : null,
            PreTelephoneNo: Telephone != null ? Telephone[0] : null,
            PreTelephoneNo1: Telephone1 != null ? Telephone1[0] : null,
          }, () => this.fillIsdCodes());

          const checkService = data.data["data"][0]["AccountType"];

          if (
            checkService == "Savingaccount" ||
            checkService == "Currentaccount" ||
            checkService == "Overdraftaccount"
          ) {
            this.setState({
              bankDtlAccountType: data.data["data"][0]["AccountType"],
            });
          } else {
            this.setState({
              bankDtlAccountType: "Others",
              bankDtlAccountTypeOthers: data.data["data"][0]["AccountType"],
            });
          }

          console.log(
            "data.data['data'][0]['MobileNo'][0]",
            data.data["data"][0]["MobileNo"][1]
          );

          if (
            this.props.location.state != null &&
            this.props.location.state.AccountType != null &&
            this.props.location.state.AccountType == "Enroll"
          ) {
            await this.getFillList(
              HallZoneListActionId,
              sessionStorage.getItem("sessionExhibitionID"),
              "",
              "",
              "",
              ""
            );
          } else {
            const HallZoneList = await this.getFillList(
              HallZoneListActionId,
              data.data["HallZoneList"][0]["ExhibitionID"],
              "",
              "",
              "",
              ""
            );
            setTimeout(async () => {
              const array2 = [];
              for (let i = 0; i < array.length; i++) {
                array2.push({
                  ...array[i],
                  HallZoneList: HallZoneList,
                });
              }
              const filterArray = this.applyCheckedFromMapping(
                array2,
                data.data["HallZoneList"]
              );
              console.log("filterArray--->", filterArray);
              this.setState({
                renderHallZoneList: filterArray,
                exhibitionId: data.data["HallZoneList"][0]["ExhibitionID"],
              });
            }, 500);

            const array = [];
            const { serviceTypeList } = this.state;
            serviceTypeList.map((item) => {
              data.data["serviceTypeData"].map((obj) => {
                if (item.ServiceID == obj.ServiceId) {
                  array.push(item);
                }
              });
            });
            this.setState({ renderServiceTypeList: array });
          }
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  applyCheckedFromMapping(renderHallZoneList, mappingArray) {
    return renderHallZoneList.map((service) => {
      const updatedHallZoneList = service.HallZoneList.map((hall) => {
        // Find all mapping rows for this hall + service
        const matchedMappings = mappingArray.filter(
          (m) => m.ServiceID === service.ServiceID && m.HallID === hall.HallId
        );

        if (matchedMappings.length === 0) {
          // If no match, return hall unchanged
          return hall;
        }

        // Update zones
        const updatedZones = hall.zonelist.map((zone) => {
          const match = matchedMappings.find((m) => m.ZoneID === zone.ZoneID);
          return {
            ...zone,
            isZoneCheked: !!match,
            vendorAllocationMappingID: match
              ? match.vendorAllocationMappingID
              : null,
          };
        });

        // Check if ALL zones are selected
        const allChecked =
          updatedZones.length > 0 && updatedZones.every((z) => z.isZoneCheked);

        return {
          ...hall,
          isHallChecked: true, // Hall is checked when at least one mapping exists
          zonelist: updatedZones,
          All: allChecked, // All zones selected
          Specific: !allChecked, // Some zones selected
        };
      });

      return {
        ...service,
        HallZoneList: updatedHallZoneList,
        isAllHallChecked: updatedHallZoneList.every(
          (item) => item.isHallChecked
        ),
      };
    });
  }

  handleClear() {
    this.setState({
      renderServiceTypeList: "",
      IsItmeBilling: "",
      IsVendorBilling: "",
      Approval_Rights: "",
      companyName: "",
      password: "",
      countryName: "",
      stateName: "",
      cityName: "",
      pinCode: "",
      address1: "",
      address2: "",
      title_inchargeFirstName: "",
      inchargeFirstName: "",
      lastNamePersonIncharge: "",
      designation: "",
      registerMobileNo: "",
      registerAlternateMobileNo: "",
      registerTelephoneNo: "",
      registerTelephoneNo1: "",
      registerTelefaxNo: "",
      primaryEmailId: "",
      secondaryEmailId: "",
      website: "",
      title_name_Of_CEO_MD_President_Owner: "",
      nameOfOwner: "",
      lastName: "",
      ownerMobileNo: "",
      ownerEmailId: "",
      compInfoNameOnPanCard: "",
      compInfoPanNo: "",
      compInfoTAN: "",
      compInfoGstNo: "",
      compInfoRegistrationNo: "",
      compInfoIecCode: "",
      bankDtlAccountName: "",
      bankDtlAccountNo: "",
      bankDtlAccountType: "",
      bankDtlAccountTypeOthers: "",
      bankDtlBankName: "",
      bankDtlBranchName: "",
      bankDtlIfscCode: "",
      PreMobileNo: "",
      PreAlternateMobileNo: "",
      PreTelephoneNo: "",
      PreTelephoneNo1: "",
      preMobile: "",
    });
  }

  addVendor(isEmailSend) {
    const {
      renderServiceTypeList,
      IsItmeBilling,
      IsVendorBilling,
      Approval_Rights,
      companyName,
      password,
      countryName,
      stateName,
      cityName,
      pinCode,
      address1,
      address2,
      title_inchargeFirstName,
      inchargeFirstName,
      lastNamePersonIncharge,
      designation,
      registerMobileNo,
      registerAlternateMobileNo,
      registerTelephoneNo,
      registerTelephoneNo1,
      registerTelefaxNo,
      primaryEmailId,
      secondaryEmailId,
      website,
      title_name_Of_CEO_MD_President_Owner,
      nameOfOwner,
      lastName,
      ownerMobileNo,
      ownerEmailId,
      compInfoNameOnPanCard,
      compInfoPanNo,
      compInfoTAN,
      compInfoGstNo,
      compInfoRegistrationNo,
      compInfoIecCode,
      bankDtlAccountName,
      bankDtlAccountNo,
      bankDtlAccountType,
      bankDtlAccountTypeOthers,
      bankDtlBankName,
      bankDtlBranchName,
      bankDtlIfscCode,
      PreMobileNo,
      PreAlternateMobileNo,
      PreTelephoneNo,
      PreTelephoneNo1,
      preMobile,
      EmpanelmentFee,
      renderHallZoneList,
      YearOfEstablishment,
      NoOfStaff,
      NoOfEventHandled,
      ShortDescription,
      USP,
      ClientEventList,
      isVendor,
      showDDDetails,
      DD_SubmittedBy_CompanyName,
      DD_Number,
      DD_Amount,
      DD_Date,
      DD_BankName,
      DD_SubmittedBy_PersonName,
      DD_SubmittedBy_MobileNo,
      DD_SubmittedBy_EmailId,
      DD_ReturnTo_CompanyName,
      DD_ReturnTo_PersonName,
      DD_ReturnTo_MobileNo,
      DD_ReturnTo_EmailId,
      DD_FileName,
      DD_FilePath, hallList,
      DD_FileType,
      DD_SubContractorList,
      DD_SameAsAbove,
      VendorID,
    } = this.state;

    this.setState({ isLoading: true });
    this.inputValidate();
    const result = this.getSelectedZones(renderHallZoneList);

    console.log("result--->", result);
    // if (
    //     renderServiceTypeList != '' && companyName != '' && countryName != '' && countryName != 'Select' && stateName != '' && cityName != '' && pinCode != '' && address1 != '' && inchargeFirstName != '' && lastNamePersonIncharge != '' && designation != '' && registerMobileNo != '' && primaryEmailId != '' && nameOfOwner != '' && ownerEmailId != '' &&
    //     renderServiceTypeList != null && companyName != null && countryName != null && stateName != null && cityName != null && pinCode != null && address1 != null && inchargeFirstName != null && lastNamePersonIncharge != null && designation != null && registerMobileNo != null && primaryEmailId != null && nameOfOwner != null && ownerEmailId != null
    // ) {
    if (
      renderServiceTypeList != "" &&
      companyName != "" &&
      inchargeFirstName != "" &&
      lastNamePersonIncharge != "" &&
      primaryEmailId != "" &&
      renderServiceTypeList != null &&
      companyName != null &&
      inchargeFirstName != null &&
      lastNamePersonIncharge != null &&
      primaryEmailId != null &&
      registerMobileNo != "" &&
      registerMobileNo != null &&
      countryName != "" &&
      countryName != "Select" &&
      (IsItmeBilling || IsVendorBilling)
    ) {
      var errMsg1 = emailValidator(primaryEmailId);
      var errMsg2 = "";
      var panErrMsg = panNoValidator(compInfoPanNo);
      var gstErrMsg = gstNoValidator(compInfoGstNo);
      var tanErrMsg = tanNoValidator(compInfoTAN);
      var pincodeErrMsg = pincodeValidator(pinCode);
      var mobileErrMsg = countryName == 91 ? contactNoValidator(registerMobileNo) : '';
      if (errMsg1 != "" || errMsg2 != "" || mobileErrMsg != "") {
        toast.error(
          errMsg1 != ""
            ? errMsg1
            : errMsg2 != ""
              ? errMsg2
              : mobileErrMsg != ""
                ? mobileErrMsg
                : "",
          {
            theme: "colored",
            autoClose: 1000,
            hideProgressBar: true,
          }
        );
        this.setState({ isLoading: false });
      } else if (panErrMsg != "" || gstErrMsg != "" || tanErrMsg != "") {
        toast.error(
          panErrMsg != ""
            ? panErrMsg
            : tanErrMsg != ""
              ? tanErrMsg
              : gstErrMsg != ""
                ? gstErrMsg
                : "",
          {
            theme: "colored",
            autoClose: 1000,
            hideProgressBar: true,
          }
        );
        this.setState({ isLoading: false });
      } else {
        if (result == true) {
          this.setState({ isLoading: false });
          return;
        }
        this.props
          .addVendorRegistration_action(
            primaryEmailId,
            title_inchargeFirstName,
            inchargeFirstName,
            lastNamePersonIncharge,
            registerMobileNo,
            registerAlternateMobileNo,
            registerTelephoneNo,
            registerTelephoneNo1,
            companyName,
            address1,
            address2,
            cityName,
            stateName,
            pinCode,
            countryName,
            secondaryEmailId,
            website,
            registerTelefaxNo,
            designation,
            title_name_Of_CEO_MD_President_Owner,
            nameOfOwner,
            lastName,
            compInfoNameOnPanCard,
            compInfoPanNo,
            compInfoTAN,
            compInfoGstNo,
            compInfoRegistrationNo,
            compInfoIecCode,
            bankDtlAccountName,
            bankDtlAccountNo,
            bankDtlAccountType == "Others"
              ? bankDtlAccountTypeOthers
              : bankDtlAccountType,
            bankDtlBankName,
            bankDtlBranchName,
            bankDtlIfscCode,
            PreMobileNo,
            PreAlternateMobileNo,
            PreTelephoneNo,
            PreTelephoneNo1,
            renderServiceTypeList,
            IsItmeBilling,
            IsVendorBilling,
            Approval_Rights,
            ownerEmailId,
            ownerMobileNo,
            preMobile,
            EmpanelmentFee,
            result,
            YearOfEstablishment,
            NoOfStaff,
            NoOfEventHandled,
            ShortDescription,
            USP,
            ClientEventList,
            showDDDetails
              ? {
                VendorID: 0,
                DD_Number,
                DD_Amount,
                DD_Date,
                DD_BankName,
                DD_SubmittedBy_CompanyName,
                DD_SubmittedBy_PersonName,
                DD_SubmittedBy_MobileNo,
                DD_SubmittedBy_EmailId,
                DD_ReturnTo_CompanyName,
                DD_ReturnTo_PersonName,
                DD_ReturnTo_MobileNo,
                DD_ReturnTo_EmailId,
                DD_FileName,
                DD_FilePath,
                DD_FileType,
                DD_SubContractorList,
                IsSameAsAbove: DD_SameAsAbove,
              }
              : null,
            isEmailSend
          )
          .then((data) => {
            if (data.error != 1) {
              this.setState({ isOpen2: false });
              var tempList = [data.data[0].AccountID]
              this.props
                .getAPDetails_action('', tempList.toString())
                .then((data) => {
                  if (data.error != 1) {
                    var tempAPlist = []
                    tempList.map(item => {
                      var obj = { EmpanelVendorID: item, hallList: [] }
                      hallList.map(item2 => {
                        obj.hallList.push({ HallId: item2.HallId, ExhibitionID: sessionStorage.getItem("sessionExhibitionID"), ExhregistrationID: '', NonEmpanelVendorID: '', EmpanelVendorID: item, IsAccess: true })
                      })
                      if (data.data[0].length > 0) {
                        data.data[0].map(item2 => {
                          if (item == item2.EmpanelVendorID) {
                            hallList.map((item3, i) => {
                              if (item2.HallID == item3.HallId) {
                                obj.hallList[i].ExhibitionID = item2.ExhibitionID
                                obj.hallList[i].EmpanelVendorID = item
                                obj.hallList[i].NonEmpanelVendorID = item2.NonEmpanelVendorID
                                obj.hallList[i].ExhregistrationID = item2.ExhRegistrationID
                                // obj.hallList[i].IsAccess = item2.AccessStatus == 'Yes' ? true : false
                              }
                            })
                          }
                        })
                      }
                      tempAPlist.push(obj)
                    })
                    var finalList = []
                    tempAPlist.map(item => {
                      item.hallList.map(item2 => {
                        finalList.push(item2)
                      })
                    })
                    this.setState({ isLoading: true });
                    this.props
                      .insertUpdateAP_action(finalList)
                      .then((data) => {
                        if (data.error != 1) {
                          toastSuccess("Service Partner added successfully!");
                          // toastSuccess("Access control updated successfully")
                          this.setState({ isLoading: false });
                          setTimeout(() => {
                            this.handleClear();
                            this.cancle();
                          }, 500);
                        }
                      }).catch((err) => {
                        console.log(err);
                      });
                    // toastSuccess("Generated Successful
                    // this.setState({ accessControlList: tempAPlist, isOpenAc: true })
                    // this.getExhibitorList();
                    // this.setState({ isLoading: false });
                  } else {
                    toastError(data.error)
                    this.setState({ isLoading: false, isOpen2: false });
                  }
                })
                .catch((err) => {
                  console.log(err);
                });
            } else {
              this.setState({ isLoading: false });
              toastError(data.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    } else {
      this.setState({ isLoading: false });
      toastError("please enter mandatory fields!");
    }
  }

  getSelectedZones(data) {
    const results = [];

    for (const service of data) {
      // ✅ halls that are checked
      const hallsChecked = service.HallZoneList.filter(
        (hall) => hall.isHallChecked
      );

      if (hallsChecked.length === 0) {
        // ❌ no hall selected in this service
        toastError("Please select atleast 1 hall for the selected services.");
        return true;
      }

      for (const hall of hallsChecked) {
        const checkedZones = (hall.zonelist || []).filter(
          (z) => z.isZoneCheked
        );
        console.log("checkedZones-------------->", checkedZones)
        if (checkedZones.length === 0) {
          // ❌ hall selected but no zone selected
          toastError("Please select a zone for the selected hall.");
          return true;
        }

        checkedZones.forEach((zone) => {
          results.push({
            HallID: hall.HallId,
            ZoneID: zone.ZoneID,
            vendorAllocationMappingID: zone.vendorAllocationMappingID
              ? zone.vendorAllocationMappingID
              : null,
            ServiceID: service.ServiceID,
          });
        });
      }
    }

    // ✅ only reached if all conditions satisfied
    return results;
  }

  updateVendor() {
    const {
      renderServiceTypeList,
      IsItmeBilling,
      IsVendorBilling,
      Approval_Rights,
      companyName,
      password,
      countryName,
      stateName,
      cityName,
      pinCode,
      address1,
      address2,
      title_inchargeFirstName,
      inchargeFirstName,
      lastNamePersonIncharge,
      designation,
      registerMobileNo,
      registerAlternateMobileNo,
      registerTelephoneNo,
      registerTelephoneNo1,
      registerTelefaxNo,
      primaryEmailId,
      secondaryEmailId,
      website,
      title_name_Of_CEO_MD_President_Owner,
      nameOfOwner,
      lastName,
      ownerMobileNo,
      ownerEmailId,
      compInfoNameOnPanCard,
      compInfoPanNo,
      compInfoTAN,
      compInfoGstNo,
      compInfoRegistrationNo,
      compInfoIecCode,
      bankDtlAccountName,
      bankDtlAccountNo,
      bankDtlAccountType,
      bankDtlAccountTypeOthers,
      bankDtlBankName,
      bankDtlBranchName,
      bankDtlIfscCode,
      PreMobileNo,
      PreAlternateMobileNo,
      PreTelephoneNo,
      PreTelephoneNo1,
      preMobile,
      EmpanelmentFee,
      renderHallZoneList,
      YearOfEstablishment,
      NoOfStaff,
      NoOfEventHandled,
      ShortDescription,
      USP,
      ClientEventList,
      isVendor,
      showDDDetails,
      DD_Number,
      DD_Amount,
      DD_Date,
      DD_BankName,
      DD_SubmittedBy_CompanyName,
      DD_SubmittedBy_PersonName,
      DD_SubmittedBy_MobileNo,
      DD_SubmittedBy_EmailId,
      DD_ReturnTo_CompanyName,
      DD_ReturnTo_PersonName,
      DD_ReturnTo_MobileNo,
      DD_ReturnTo_EmailId,
      DD_FileName,
      DD_FilePath,
      DD_FileType,
      DD_SubContractorList,
      DD_SameAsAbove,
      VendorID,
    } = this.state;

    this.setState({ isLoading: true });
    this.inputValidate();

    const result = this.getSelectedZones(renderHallZoneList);
    const RoleID = 12;

    const id =
      (this.props.location.state && this.props.location.state.AccountID) ||
      sessionStorage.getItem("AccountIDSS");

    if (
      renderServiceTypeList != "" &&
      companyName != "" &&
      inchargeFirstName != "" &&
      lastNamePersonIncharge != "" &&
      primaryEmailId != "" &&
      renderServiceTypeList != null &&
      companyName != null &&
      inchargeFirstName != null &&
      lastNamePersonIncharge != null &&
      primaryEmailId != null &&
      countryName != "" &&
      countryName != "Select" &&
      registerMobileNo != "" &&
      registerMobileNo != null &&
      (IsItmeBilling || IsVendorBilling) &&
      (isVendor
        ? YearOfEstablishment != null &&
        YearOfEstablishment != "" &&
        NoOfStaff != null &&
        NoOfStaff != "" &&
        NoOfEventHandled != null &&
        NoOfEventHandled != "" &&
        ShortDescription != null &&
        ShortDescription != "" &&
        USP != null &&
        USP != "" &&
        ClientEventList != null &&
        ClientEventList != ""
        : true) &&
      (!showDDDetails ||
        (DD_Number &&
          DD_Amount &&
          DD_Date &&
          DD_BankName &&
          DD_SubmittedBy_CompanyName &&
          DD_SubmittedBy_PersonName &&
          DD_SubmittedBy_MobileNo &&
          DD_SubmittedBy_EmailId &&
          DD_ReturnTo_CompanyName &&
          DD_ReturnTo_PersonName &&
          DD_ReturnTo_MobileNo &&
          DD_ReturnTo_EmailId &&
          DD_FileName))
    ) {
      var errMsg1 = emailValidator(primaryEmailId);
      var errMsg2 = "";
      var panErrMsg = panNoValidator(compInfoPanNo);
      var gstErrMsg = gstNoValidator(compInfoGstNo);
      var tanErrMsg = tanNoValidator(compInfoTAN);
      var pincodeErrMsg = pincodeValidator(pinCode);
      var mobileErrMsg = countryName == 91 ? contactNoValidator(registerMobileNo) : ''

      if (errMsg1 != "" || errMsg2 != "" || mobileErrMsg != "") {
        toast.error(
          errMsg1 != ""
            ? errMsg1
            : errMsg2 != ""
              ? errMsg2
              : mobileErrMsg != ""
                ? mobileErrMsg
                : "",
          {
            theme: "colored",
            autoClose: 1000,
            hideProgressBar: true,
          }
        );
        this.setState({ isLoading: false });
      } else if (panErrMsg != "" || gstErrMsg != "" || tanErrMsg != "") {
        toast.error(
          panErrMsg != ""
            ? panErrMsg
            : tanErrMsg != ""
              ? tanErrMsg
              : gstErrMsg != ""
                ? gstErrMsg
                : "",
          {
            theme: "colored",
            autoClose: 1000,
            hideProgressBar: true,
          }
        );
        this.setState({ isLoading: false });
      } else {
        if (result === true) {
          this.setState({ isLoading: false });
          return;
        }
        this.props
          .updateVendorRegistration_action(
            primaryEmailId,
            title_inchargeFirstName,
            inchargeFirstName,
            lastNamePersonIncharge,
            registerMobileNo,
            registerAlternateMobileNo,
            registerTelephoneNo,
            registerTelephoneNo1,
            companyName,
            address1,
            address2,
            cityName,
            stateName,
            pinCode,
            countryName,
            secondaryEmailId,
            website,
            registerTelefaxNo,
            designation,
            title_name_Of_CEO_MD_President_Owner,
            nameOfOwner,
            lastName,
            compInfoNameOnPanCard,
            compInfoPanNo,
            compInfoTAN,
            compInfoGstNo,
            compInfoRegistrationNo,
            compInfoIecCode,
            bankDtlAccountName,
            bankDtlAccountNo,
            bankDtlAccountType == "Others"
              ? bankDtlAccountTypeOthers
              : bankDtlAccountType,
            bankDtlBankName,
            bankDtlBranchName,
            bankDtlIfscCode,
            PreMobileNo,
            PreAlternateMobileNo,
            PreTelephoneNo,
            PreTelephoneNo1,
            id,
            renderServiceTypeList,
            IsItmeBilling,
            IsVendorBilling,
            Approval_Rights,
            ownerEmailId,
            ownerMobileNo,
            preMobile,
            EmpanelmentFee,
            result,
            YearOfEstablishment,
            NoOfStaff,
            NoOfEventHandled,
            ShortDescription,
            USP,
            ClientEventList,
            showDDDetails
              ? {
                VendorID,
                DD_Number,
                DD_Amount,
                DD_Date,
                DD_BankName,
                DD_SubmittedBy_CompanyName,
                DD_SubmittedBy_PersonName,
                DD_SubmittedBy_MobileNo,
                DD_SubmittedBy_EmailId,
                DD_ReturnTo_CompanyName,
                DD_ReturnTo_PersonName,
                DD_ReturnTo_MobileNo,
                DD_ReturnTo_EmailId,
                DD_FileName,
                DD_FilePath,
                DD_FileType,
                DD_SubContractorList,
                IsSameAsAbove: DD_SameAsAbove,
              }
              : null
          )
          .then((data) => {
            if (data.error != 1) {
              this.setState({ isLoading: false });
              if (isVendor) {
                toastSuccess("Profile updated successfully!");
              } else {
                toastSuccess("Service Partner Profile update successfully!");
              }
              if (!isVendor) {
                setTimeout(() => {
                  this.handleClear();
                  this.cancle();
                }, 2000);
              }
            } else {
              this.setState({ isLoading: false });
              toastError(data.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    } else {
      this.setState({ isLoading: false });
      toastError("please enter mandatory fields!");
    }
  }

  cancle() {
    if (this.props.isEmbedded) {
      window.dispatchEvent(new CustomEvent('vendorNavigate', { detail: 'vendorDashboard' }));
      return;
    }
    window.history.back();
  }

  handleTableInput(e, serviceName, i, type, param, zoneIndex) {
    this.setState((prevState) => {
      const updatedList = prevState.renderHallZoneList.map((item) => {
        if (item.Name !== serviceName) return item;

        return {
          ...item,
          HallZoneList: item.HallZoneList.map((obj, index) => {
            if (index !== i) return obj;

            // RADIO toggle
            if (type === "radio") {
              return {
                ...obj,
                All: param === "All",
                Specific: param !== "All",
                zonelist: obj.zonelist.map((zone) => ({
                  ...zone,
                  isZoneCheked: param === "All", // tick/untick all
                })),
              };
            }

            // HALL toggle
            if (type === "hall") {
              let updatedZones = obj.zonelist;
              let allChecked = obj.All;

              if (!e.target.checked) {
                updatedZones = obj.zonelist.map((zone) => ({
                  ...zone,
                  isZoneCheked: true,
                }));
                allChecked = true;
              }

              return {
                ...obj,
                isHallChecked: e.target.checked,
                zonelist: updatedZones,
                All: allChecked,
                Specific: !allChecked,
              };
            }

            // ZONELIST toggle (individual checkbox)
            if (type === "zonelist") {
              const updatedZones = obj.zonelist.map((zone, zIndex) => {
                if (zIndex !== zoneIndex) return zone;
                return {
                  ...zone,
                  isZoneCheked: e.target.checked,
                };
              });

              // check if ALL zones are checked
              const allChecked = updatedZones.every((z) => z.isZoneCheked);

              return {
                ...obj,
                zonelist: updatedZones,
                All: allChecked,
                Specific: !allChecked,
              };
            }

            return obj;
          }),
        };
      });

      console.log("updated renderHallZoneList -->", updatedList);
      return { renderHallZoneList: updatedList };
    });
  }

  handleAllHallChecked = (e, serviceIndex) => {
    const isChecked = e.target.checked;

    this.setState((prevState) => {
      const updatedList = prevState.renderHallZoneList.map((service, idx) => {
        if (idx !== serviceIndex) return service;

        return {
          ...service,
          isAllHallChecked: isChecked,
          HallZoneList: service.HallZoneList.map((hall) => ({
            ...hall,
            isHallChecked: isChecked,
            All: true,
            Specific: false,
            zonelist: hall.zonelist.map((zone) => ({
              ...zone,
              isZoneCheked: true,
            })),
          })),
        };
      });

      return { renderHallZoneList: updatedList };
    });
  };

  render() {
    const {
      isLoading,
      countryName,
      registerMobileNo,
      registerMobileNoErr,
      serviceTypeErr,
      companyName,
      address1,
      address2,
      cityName,
      stateName,
      pinCode,
      inchargeFirstName,
      designation,
      registerAlternateMobileNo,
      registerTelephoneNo,
      registerTelephoneNo1,
      registerTelefaxNo,
      primaryEmailId,
      secondaryEmailId,
      website,
      nameOfOwner,
      lastName,
      ownerMobileNo,
      ownerEmailId,
      title_inchargeFirstName,
      title_name_Of_CEO_MD_President_Owner,
      companyNameErr,
      address1Err,
      cityNameErr,
      stateNameErr,
      pinCodeErr,
      countryNameErr,
      inchargeFirstNameErr,
      designationErr,
      primaryEmailIdErr,
      nameOfOwnerErr,
      ownerEmailIdErr,
      compInfoNameOnPanCard,
      compInfoPanNo,
      compInfoTAN,
      compInfoGstNo,
      compInfoRegistrationNo,
      compInfoIecCode,
      bankDtlAccountName,
      bankDtlAccountNo,
      bankDtlAccountType,
      bankDtlBankName,
      bankDtlBranchName,
      bankDtlIfscCode,
      compInfoNameOnPanCardErr,
      compInfoPanNoErr,
      compInfoTANErr,
      compInfoGstNoErr,
      compInfoRegistrationNoErr,
      bankDtlAccountNameErr,
      bankDtlAccountNoErr,
      bankDtlIfscCodeErr,
      isCountryIndia,
      isDisplayCityList,
      isDisplayStateList,
      isDisplayPincodeList,
      lastNamePersonIncharge,
      lastNamePersonInchargeErr,
      bankDtlAccountTypeOthers,
      add,
      countryList,
      exhibitionList,
      exhibitionId,
      bankDtlAccountTypeOthersErr,

      serviceTypeId,
      serviceTypeList,
      renderServiceTypeList,
      password,
      passwordErr,
      IsItmeBilling,
      IsVendorBilling,
      Approval_Rights,
      countryCode,
      bankDtlAccountTypeErr,
      isHallManager,
      showVideoModal,
      PreMobileNo,
      PreAlternateMobileNo,
      PreTelephoneNo,
      PreTelephoneNo1,
      preMobile,
      HallZoneList,
      renderHallZoneList,
      EmpanelmentFee,
      AccountType,
      update,
      YearOfEstablishment,
      NoOfStaff,
      NoOfEventHandled,
      ShortDescription,
      isVendor,
      ClientEventList,
      USP,
      isWorkUpdation,
      isOpen2
    } = this.state;

    const toInputUppercase = (e) => {
      e.target.value = ("" + e.target.value).toUpperCase();
    };

    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        {isVendor && showVideoModal && (
          <div
            className="modal show d-block"
            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
            onClick={() => this.setState({ showVideoModal: false })}
          >
            <div
              className="modal-dialog modal-lg modal-dialog-centered"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Profile</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => this.setState({ showVideoModal: false })}
                  ></button>
                </div>
                <div className="modal-body">
                  <video controls autoPlay style={{ width: "100%" }}>
                    <source src="/assets/VendorProfile.mp4" type="video/mp4" />
                  </video>
                </div>
              </div>
            </div>
          </div>
        )}
        {!isHallManager && (
          <>
            {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ? (
              <ExhibitorHeader />
            ) : (
              <HeaderWithLogo />
            )}
            {(JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 7 || JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 17) ? (
              <VendorDrawer />
            ) : (
              <AdminDrawer />
            )}
            {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ? (
              <ExhibitorTopMenu />
            ) : null}
          </>
        )}
        <div
          className={
            isHallManager
              ? ""
              : isVendor
                ? "with-dr-container com-height mt-0"
                : "with-dr-container com-height"
          }
          style={{
            margin: isVendor ? 0 : "",
            marginTop: isHallManager ? "85px" : "",
          }}
        >
          <>
            {/* PAGE */}
            <div className="page">
              <div className="page-main">
                {!isVendor && !isWorkUpdation && (
                  <div class="row">
                    {/* <div class="tab-scroll-fixed"> */}
                    <div className="breadcrumb-scroll-fixed">
                      <h6 className="mb-0 px-4 py-2 text-white">
                        {add || AccountType == "Enroll"
                          ? "Service Partner Registration"
                          : "Update Service Partner"}
                      </h6>
                    </div>
                  </div>
                )}
                {/*app-content open*/}
                <div className="main-content app-content vendor-top-space">
                  <div className="side-app p-2">
                    {/* <div className="main-container form-start container-fluid p-0">
                                        {is_update && <>
                                            <div className="row ">
                                                <div className="tab-scroll-fixed">
                                                    <p>Exhibitor Registration</p>
                                                </div>
                                            </div>
                                            <StepHeader />
                                        </>}
                                    </div> */}
                    {/* <StepHeader /> */}
                    {/* <div className="page-height"> */}
                    <div className="main-container pt-3 px-0 px-md-0">
                      {/* {isVendor && (
                        <div
                          className="d-flex justify-content-end mb-2 mt-1
                        "
                        >
                          <span
                            onClick={() =>
                              this.setState({ showVideoModal: true })
                            }
                            style={{
                              cursor: "pointer",
                              color: "#3dbca7",
                              fontSize: "16px",
                            }}
                          >
                            <i className="bi bi-play-circle-fill me-2"></i>User
                            Manual
                          </span>
                        </div>
                      )} */}
                      <div className="row m-0">
                        <div className="form-row">
                          {/* <div className="col-md-3">
                                                        <label>Exhibition</label>
                                                        <select
                                                            className="form-control"
                                                            id="roledb"
                                                            // style={{ textAlign: "left" }}
                                                            value={exhibitionId}
                                                            onChange={(e) => this.setState({ exhibitionId: e.target.value }, () => {
                                                                this.setState({
                                                                    serviceTypeId: '',
                                                                    renderHallZoneList: [],
                                                                    renderServiceTypeList: []
                                                                })
                                                                this.getFillList(HallZoneListActionId, e.target.value, '', '', '', '')
                                                            })}
                                                        >
                                                            {exhibitionList.length > 0 && exhibitionList.map((data) => (
                                                                <option key={data.ExhibitionID
                                                                } value={data.ExhibitionID
                                                                }>{data.ExhibitionName}</option>
                                                            ))}
                                                        </select>
                                                    </div> */}
                          {!isVendor && (
                            <div className="col-md-3">
                              <label htmlFor="validationCustom03">
                                Service Type<span className="text-red">*</span>
                              </label>
                              <select
                                className="form-control mb-2"
                                // style={{ textAlign: "left" }}
                                disabled={
                                  exhibitionId == "" ||
                                  exhibitionId == null ||
                                  isVendor
                                }
                                value={serviceTypeId}
                                onChange={(e) => this.onServiceType(e)}
                              >
                                <option>Select</option>
                                {serviceTypeList.length > 0 &&
                                  serviceTypeList.map((data) => (
                                    <option
                                      key={data.ServiceID}
                                      value={data.ServiceID}
                                    >
                                      {data.DisplayName}
                                    </option>
                                  ))}
                              </select>
                              {
                                <span className="text-danger text-start text-left d-block mt-1">
                                  {serviceTypeErr}
                                </span>
                              }
                            </div>
                          )}
                        </div>

                        <div className="form-row">
                          <div className="col-12 col-lg-3">
                            <div className="card shadow-none my-0">
                              <div className="card-header bg-light text-dark border py-2">
                                <div className="form-check mb-0 px-0">
                                  <label className="form-check-label">
                                    Services
                                    <span className="text-danger">*</span>
                                  </label>
                                </div>
                              </div>
                              <ul
                                className="list-group list-group-flush border border-top-0"
                                style={{
                                  padding:
                                    renderServiceTypeList.length == 0
                                      ? "11px"
                                      : 0,
                                }}
                              >
                                {/* Service Item */}
                                {renderServiceTypeList.length > 0 ? (
                                  renderServiceTypeList.map((data) => (
                                      <li
                                        className="list-group-item"
                                        style={{ padding: "6px 13px" }}
                                        key={data.ServiceID}
                                      >
                                        <div className="d-flex justify-content-between align-items-center">
                                          <label className="mb-0">{data.DisplayName}</label>
                                          {!isVendor && (
                                            <i
                                              className="fa fa-trash text-danger"
                                              onClick={() =>
                                                this.deleteServiceType(
                                                  data.ServiceID
                                                )
                                              }
                                              style={{ cursor: "pointer" }}
                                            ></i>
                                          )}
                                        </div>
                                      </li>
                                  ))
                                ) : (
                                  <li className="text-center">
                                    Record not found
                                  </li>
                                )}
                              </ul>
                            </div>
                          </div>
                          {/* <div className="col-md-3">
                                                        <div className="card shadow-none mb-0 mt-3">
                                                            <div className="card-header bg-light text-dark border py-2">
                                                                <div className="form-check mb-0 px-0">
                                                                    <label className="form-check-label" htmlFor="hall1">
                                                                        Billing<span className="text-danger">*</span>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <ul className="list-group list-group-flush border border-top-0">
                                                                <li className="list-group-item py-1">
                                                                    <div className="row">
                                                                        <div className="col-6">
                                                                            <div className="form-check">
                                                                                <input type="checkbox"
                                                                                    id="hall1-z0"
                                                                                    className="form-check-input zone-checkbox"
                                                                                    name="IsItmeBilling"
                                                                                    checked={IsItmeBilling}
                                                                                    onChange={(e) => this.setState({ IsItmeBilling: e.target.checked })}
                                                                                />
                                                                                <label className="form-check-label" htmlFor="hall1-z0">
                                                                                    ITME
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-6">
                                                                            <div className="form-check">
                                                                                <input type="checkbox"
                                                                                    id="hall1-z1"
                                                                                    className="form-check-input zone-checkbox"
                                                                                    checked={IsVendorBilling}
                                                                                    onChange={(e) => this.setState({ IsVendorBilling: e.target.checked })}
                                                                                    name="IsVendorBilling" />
                                                                                <label className="form-check-label" htmlFor="hall1-z1">
                                                                                    Direct
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div> */}
                          {!isVendor && (
                            <div className="col-md-2">
                              <div className="card shadow-none mb-0">
                                <div className="card-header bg-light text-dark border py-2">
                                  <div className="form-check mb-0 px-0">
                                    <label
                                      className="form-check-label"
                                      htmlFor="hall1"
                                    >
                                      Empanelment Fee
                                    </label>
                                  </div>
                                </div>
                                <ul className="list-group list-group-flush border border-top-0 p-1">
                                  <li className="list-group-item py-1">
                                    <div className="row">
                                      <input
                                        type="text"
                                        className="form-control"
                                        value={EmpanelmentFee}
                                        onChange={(e) =>
                                          this.setState({
                                            EmpanelmentFee:
                                              e.target.value.replace(/\D/g, ""),
                                          })
                                        }
                                        maxLength={10}
                                        defaultValue=""
                                        style={{ height: 29 }}
                                      />
                                    </div>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          )}
                        </div>

                        <div className="form-row mt-2 m-0">
                          <div className="col-xl-6 mb-1 px-0">
                            <label htmlFor="validationCustom03">
                              Company Name<span className="text-red">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="validationCustom03"
                              required=""
                              value={companyName}
                              disabled={isVendor}
                              maxLength={150}
                              onChange={(e) =>
                                this.setState({
                                  companyName: e.target.value
                                    .split(" ")
                                    .map(
                                      (word) =>
                                        word.charAt(0).toUpperCase() +
                                        word.slice(1)
                                    )
                                    .join(" "),
                                  companyNameErr: "",
                                })
                              }
                            />
                            {
                              <span className="text-danger text-start text-left d-block mt-1">
                                {companyNameErr}
                              </span>
                            }
                          </div>
                          {/* <div className="col-xl-3 mb-1">
                                                        <label htmlFor="validationCustom01">
                                                            Password <span className="text-red">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            maxLength={200}
                                                            required=""
                                                            value={password}
                                                            onChange={e => this.setState({ password: e.target.value, address1Err: '' })} />
                                                        {<span className='text-danger text-start text-left d-block mt-1'>{passwordErr}</span>}

                                                    </div> */}
                        </div>

                        <div className="form-row mt-1">
                          <div className="col-xl-3 mb-1">
                            <label htmlFor="validationCustom01">
                              Country
                              <span className="text-red">*</span>
                            </label>
                            <select
                              className="form-control"
                              // style={{ textAlign: "left" }}
                              value={countryName}
                              onChange={(e) => this.onCountry(e)}
                            >
                              <option value={""}>Select</option>
                              {countryList.length > 0 &&
                                countryList.map((data) => (
                                  <option key={data.Code} value={data.Code}>
                                    {data.Description}
                                  </option>
                                ))}
                            </select>
                            {
                              <span className="text-danger text-start text-left d-block mt-1">
                                {countryNameErr}
                              </span>
                            }
                          </div>
                          <div className="col-xl-3 mb-1">
                            <label htmlFor="validationCustom01">
                              State/Province
                              {/* {countryName == '' || countryName == 'Select' || countryName == 91 ? <span className="text-red">*</span> : <></>} */}
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              maxLength={30}
                              required=""
                              value={stateName}
                              onChange={(e) => this.onStateSearch(e)}
                            />
                            {isDisplayStateList && this.renderStateList()}
                            {
                              <span className="text-danger text-start text-left d-block mt-1">
                                {stateNameErr}
                              </span>
                            }
                          </div>
                          <div className="col-xl-3 mb-1">
                            <label htmlFor="validationCustom01">
                              City
                              {/* <span className="text-red">*</span> */}
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              maxLength={30}
                              required=""
                              value={cityName}
                              onChange={(e) => this.onCitySearch(e)}
                            />
                            {isDisplayCityList && this.renderCityList()}
                            {
                              <span className="text-danger text-start text-left d-block mt-1">
                                {cityNameErr}
                              </span>
                            }
                          </div>
                          <div className="col-xl-3 mb-1">
                            {console.log("countryName", countryName)}
                            <label htmlFor="validationCustom01">
                              {countryName == 91 ||
                                countryName == "" ||
                                countryName == "Select"
                                ? "Pincode"
                                : "Zipcode"}
                              {/* <span className="text-red">*</span> */}
                            </label>
                            {
                              <input
                                type="text"
                                className="form-control"
                                maxLength={10}
                                // onKeyPress={this.onlyNumbers}
                                required=""
                                value={pinCode}
                                onChange={(e) => this.onPincodeSearch(e)}
                                onInput={toInputUppercase}
                              // onChange={this.changeUrl}
                              />
                            }
                            {isDisplayPincodeList && this.renderPincodeList()}
                            {
                              <span className="text-danger text-start text-left d-block mt-1">
                                {pinCodeErr}
                              </span>
                            }
                          </div>
                        </div>

                        <div className="form-row">
                          <div className="col-xl-6 mb-2">
                            <label htmlFor="validationCustom01">
                              Address Line 1
                              {/* <span className="text-red">*</span> */}
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              maxLength={200}
                              required=""
                              value={address1}
                              onChange={(e) =>
                                this.setState({
                                  address1: e.target.value
                                    .split(" ")
                                    .map(
                                      (word) =>
                                        word.charAt(0).toUpperCase() +
                                        word.slice(1)
                                    )
                                    .join(" "),
                                  address1Err: "",
                                })
                              }
                            />
                            {
                              <span className="text-danger text-start text-left d-block mt-1">
                                {address1Err}
                              </span>
                            }
                          </div>
                          <div className="col-xl-6 mb-2">
                            <label htmlFor="validationCustom01">
                              Address Line 2{" "}
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              maxLength={200}
                              value={address2}
                              onChange={(e) =>
                                this.setState({
                                  address2: e.target.value
                                    .split(" ")
                                    .map(
                                      (word) =>
                                        word.charAt(0).toUpperCase() +
                                        word.slice(1)
                                    )
                                    .join(" "),
                                })
                              }
                            />
                          </div>
                        </div>

                        <div className="form-row">
                          <div className="col-xl-3 mb-3">
                            <label>
                              First Name of Person Incharge
                              <span className="text-red">*</span>
                            </label>

                            <div className="name-input-group">
                              <select
                                className="form-control name-prefix"
                                value={title_inchargeFirstName}
                                disabled={isVendor}
                                onChange={(e) =>
                                  this.setState({
                                    title_inchargeFirstName: e.target.value,
                                  })
                                }
                              >
                                <option value="Mr">Mr</option>
                                <option value="Ms">Ms</option>
                                <option value="Dr">Dr</option>
                                <option value="Prof">Prof</option>
                              </select>

                              <input
                                type="text"
                                className="form-control name-no"
                                value={inchargeFirstName}
                                onChange={(e) =>
                                  this.setState({
                                    inchargeFirstName: e.target.value
                                      .replace(/[^a-zA-Z ]/g, "")
                                      .split(" ")
                                      .map(
                                        (word) =>
                                          word.charAt(0).toUpperCase() +
                                          word.slice(1)
                                      )
                                      .join(" "),
                                    inchargeFirstNameErr: "",
                                  })
                                }
                              />
                            </div>


                            {inchargeFirstNameErr && (
                              <span className="text-danger d-block mt-1">
                                {inchargeFirstNameErr}
                              </span>
                            )}
                          </div>

                          <div className="col-xl-3 mb-3">
                            <label>
                              Last Name of Person Incharge
                              <span className="text-red">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              maxLength={100}
                              required=""
                              defaultValue=""
                              value={lastNamePersonIncharge}
                              onChange={(e) =>
                                this.setState({
                                  lastNamePersonIncharge: e.target.value
                                    .replace(/[^a-zA-Z ]/g, "")
                                    .split(" ")
                                    .map(
                                      (word) =>
                                        word.charAt(0).toUpperCase() +
                                        word.slice(1)
                                    )
                                    .join(" "),
                                  lastNamePersonInchargeErr: "",
                                })
                              }
                            />
                            {
                              <span className="text-danger text-start text-left d-block mt-1">
                                {lastNamePersonInchargeErr}
                              </span>
                            }
                          </div>
                          <div className="col-xl-3 mb-3">
                            <label htmlFor="validationCustom01">
                              Designation
                              {/* <span className="text-red">*</span> */}
                            </label>
                            <input
                              type="text"
                              maxLength={100}
                              className="form-control"
                              value={designation}
                              onChange={(e) =>
                                this.setState({
                                  designation: e.target.value
                                    .split(" ")
                                    .map(
                                      (word) =>
                                        word.charAt(0).toUpperCase() +
                                        word.slice(1)
                                    )
                                    .join(" "),
                                  designationErr: "",
                                })
                              }
                            />
                            {
                              <span className="text-danger text-start text-left d-block mt-1">
                                {designationErr}
                              </span>
                            }
                          </div>
                          <div className="col-xl-3 mb-3">
                            <label>
                              Mobile No <span className="text-red">*</span>
                            </label>

                            <div className="phone-input-group">
                              <input
                                type="text"
                                className="form-control phone-code" autoComplete="off" readOnly
                                placeholder="ISD"
                                value={this.formatIsd(PreMobileNo)}
                              />

                              <input
                                type="text"
                                className="form-control phone-no"
                                value={registerMobileNo}
                                maxLength={
                                  countryName == 91 ? 10 : 15
                                }
                                onChange={(e) =>
                                  this.setState({
                                    registerMobileNo: e.target.value.replace(/\D/g, ""),
                                    registerMobileNoErr: "",
                                  })
                                }
                              />
                            </div>

                            {registerMobileNoErr && (
                              <span className="text-danger d-block mt-1">
                                {registerMobileNoErr}
                              </span>
                            )}
                          </div>

                        </div>
                        <div className="form-row">
                          {/* <div className="col-xl-3 mb-1">
                            <label htmlFor="validationCustom01">
                              Alternate Mobile No{" "}
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={registerAlternateMobileNo}
                              maxLength={
                                countryName == 91 ||
                                countryName == "" ||
                                countryName == "Select"
                                  ? 10
                                  : 11
                              }
                              onChange={(e) =>
                                this.setState({
                                  registerAlternateMobileNo:
                                    e.target.value.replace(/\D/, ""),
                                })
                              }
                              
                            />
                            <input
                              type="text"
                              className="form-control-isd"
                              placeholder="ISD"
                              value={PreAlternateMobileNo}
                              onChange={(e) =>
                                this.setState({
                                  PreAlternateMobileNo: e.target.value,
                                })
                              }
                              maxLength={5}
                              disabled={true}
                              
                              style={{
                                width: "45px",
                                position: "absolute",
                                top: "21.5px",
                                paddingLeft: "5px",
                              }}
                            />
                          </div> */}
                          <div className="col-xl-3 mb-3">
                            <label>
                              Alternate Mobile No
                            </label>

                            <div className="phone-input-group">
                              <input
                                type="text"
                                className="form-control phone-code" autoComplete="off" readOnly
                                placeholder="ISD"
                                value={this.formatIsd(PreAlternateMobileNo)}
                              />

                              <input
                                type="text"
                                className="form-control phone-no"
                                value={registerAlternateMobileNo}
                                maxLength={countryName == 91 ? 10 : 15}
                                onChange={(e) =>
                                  this.setState({
                                    registerAlternateMobileNo: e.target.value.replace(/\D/g, ""),
                                  })
                                }
                              />
                            </div>
                          </div>


                          <div className="col-xl-3 mb-3">
                            <label>
                              Telephone No
                            </label>

                            <div className="phone-input-group">
                              <input
                                type="text"
                                className="form-control phone-code" autoComplete="off"
                                placeholder="STD"
                                value={PreTelephoneNo}
                                maxLength={5}
                                onChange={(e) =>
                                  this.setState({
                                    PreTelephoneNo: e.target.value.replace(/\D/g, ""),
                                  })
                                }
                              />

                              <input
                                type="text"
                                className="form-control phone-no"
                                value={registerTelephoneNo}
                                maxLength={20}
                                onChange={(e) =>
                                  this.setState({
                                    registerTelephoneNo: e.target.value.replace(/\D/g, ""),
                                  })
                                }
                              />
                            </div>
                          </div>

                          <div className="col-xl-3 mb-3">
                            <label>
                              Telephone No 1
                            </label>

                            <div className="phone-input-group">
                              <input
                                type="text"
                                className="form-control phone-code" autoComplete="off"
                                placeholder="STD"
                                value={PreTelephoneNo1}
                                maxLength={5}
                                onChange={(e) =>
                                  this.setState({
                                    PreTelephoneNo1: e.target.value.replace(/\D/g, ""),
                                  })
                                }
                              />

                              <input
                                type="text"
                                className="form-control phone-no"
                                value={registerTelephoneNo1}
                                maxLength={20}
                                onChange={(e) =>
                                  this.setState({
                                    registerTelephoneNo1: e.target.value.replace(/\D/g, ""),
                                  })
                                }
                              />
                            </div>
                          </div>

                          <div className="col-xl-3 mb-3">
                            <label htmlFor="validationCustom01">Telefax</label>
                            <input
                              type="text"
                              className="form-control"
                              value={registerTelefaxNo}
                              maxLength={50}
                              onChange={(e) =>
                                this.setState({
                                  registerTelefaxNo: e.target.value.replace(
                                    /\D/,
                                    ""
                                  ),
                                })
                              }
                            />
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="col-xl-3 mb-3">
                            <label htmlFor="validationCustom01">
                              Primary Email <span className="text-red">*</span>
                            </label>
                            <input
                              type="email"
                              maxLength={100}
                              className="form-control"
                              value={primaryEmailId}
                              disabled={isVendor}
                              onChange={(e) =>
                                this.setState({
                                  primaryEmailId: e.target.value,
                                  primaryEmailIdErr: "",
                                })
                              }
                            // onBlur={e => primaryEmailId != '' && this.emailFocusOut('fromprimaryemail')}
                            />
                            {
                              <span className="text-danger text-start text-left d-block mt-1">
                                {primaryEmailIdErr}
                              </span>
                            }
                          </div>
                          <div className="col-xl-3 mb-3">
                            <label htmlFor="validationCustom01">
                              Secondary Email{" "}
                            </label>
                            <input
                              type="email"
                              className="form-control"
                              maxLength={100}
                              value={secondaryEmailId}
                              onChange={(e) =>
                                this.setState({
                                  secondaryEmailId: e.target.value,
                                })
                              }
                            // onBlur={e => secondaryEmailId != '' && this.emailFocusOut('fromsecondaryemail')}
                            />
                          </div>
                          <div className="col-xl-6 mb-3">
                            <label htmlFor="validationCustom01">Website</label>
                            <input
                              type="text"
                              className="form-control"
                              maxLength={100}
                              value={website}
                              onChange={(e) =>
                                this.setState({ website: e.target.value })
                              }
                            />
                          </div>
                        </div>
                        <div className="form-row align-items-end">
                          <div className="col-xl-3 mb-3">
                            <label>
                              First Name of CEO / MD / President / Owner
                            </label>

                            <div className="name-input-group">
                              <select
                                className="form-control name-prefix"
                                value={title_name_Of_CEO_MD_President_Owner}
                                onChange={(e) =>
                                  this.setState({
                                    title_name_Of_CEO_MD_President_Owner: e.target.value,
                                  })
                                }
                              >
                                <option value="Mr">Mr</option>
                                <option value="Ms">Ms</option>
                                <option value="Dr">Dr</option>
                                <option value="Prof">Prof</option>
                                <option value="Other">Other</option>
                              </select>

                              <input
                                type="text"
                                className="form-control name-no"
                                value={nameOfOwner}
                                maxLength={100}
                                onChange={(e) =>
                                  this.setState({
                                    nameOfOwner: e.target.value
                                      .replace(/[^a-zA-Z ]/g, "")
                                      .replace(/\s+/g, " ")
                                      .trimStart(),
                                  })
                                }
                              />
                            </div>
                          </div>

                          <div className="col-xl-3 mb-3">
                            <label>
                              Last Name of CEO / MD / President / Owner
                            </label>

                            <input
                              type="text"
                              className="form-control"
                              value={lastName}
                              maxLength={100}
                              onChange={(e) =>
                                this.setState({
                                  lastName: e.target.value
                                    .replace(/[^a-zA-Z]/g, "")
                                    .split(" ")
                                    .map(
                                      (word) =>
                                        word.charAt(0).toUpperCase() +
                                        word.slice(1)
                                    )
                                    .join(" "),
                                })
                              }
                            />
                          </div>
                          <div className="col-xl-3 mb-3">
                            <label>
                              Mobile No of CEO / MD / President / Owner
                            </label>

                            <div className="phone-input-group">
                              <input
                                type="text"
                                className="form-control phone-code" autoComplete="off" readOnly
                                placeholder="ISD"
                                value={this.formatIsd(preMobile)}
                              />

                              <input
                                type="text"
                                className="form-control phone-no"
                                value={ownerMobileNo}
                                maxLength={20}
                                onChange={(e) =>
                                  this.setState({
                                    ownerMobileNo: e.target.value.replace(/\D/g, ""),
                                  })
                                }
                              />
                            </div>
                          </div>

                          <div className="col-xl-3 mb-3">
                            <label htmlFor="validationCustom01">
                              Email of CEO / MD / President / Owner
                              {/* <span className="text-red">*</span> */}
                            </label>
                            <input
                              type="email"
                              className="form-control"
                              maxLength={100}
                              value={ownerEmailId}
                              onChange={(e) =>
                                this.setState({
                                  ownerEmailId: e.target.value,
                                  ownerEmailIdErr: "",
                                })
                              }
                            />
                            {
                              <span className="text-danger text-start text-left d-block mt-1">
                                {ownerEmailIdErr}
                              </span>
                            }
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* COMPANY INFORMATION Start Here */}
                    {/* {
                                            countryName == 91 || countryName == '' || countryName == 'Select' ? */}

                    <div
                      className="main-container bg-light mt-2"
                      id="companyProfileSection"
                    >
                      <div className="container-fluid py-1 pb-3 px-2 border">
                        <h6 className="section-title fw-semibold mb-1 mt-1">
                          Company Information
                        </h6>
                        <div className="form-row ">
                          <div className="col-xl-3 mb-1">
                            <label htmlFor="validationCustom01">
                              Name On Pan Card
                            </label>
                            <input
                              type="text"
                              maxLength={100}
                              className="form-control"
                              value={compInfoNameOnPanCard}
                              onChange={(e) =>
                                this.setState({
                                  compInfoNameOnPanCard: e.target.value
                                    .replace(/[^a-zA-Z ]/g, "")
                                    .split(" ")
                                    .map(
                                      (word) =>
                                        word.charAt(0).toUpperCase() +
                                        word.slice(1)
                                    )
                                    .join(" "),
                                  compInfoNameOnPanCardErr: "",
                                })
                              }
                            />
                            <span className="text-danger text-start text-left d-block mt-1">
                              {compInfoNameOnPanCardErr}
                            </span>
                          </div>
                          <div className="col-xl-3 mb-1">
                            <label htmlFor="validationCustom01"> PAN No </label>
                            <input
                              type="text"
                              maxLength={10}
                              className="form-control"
                              value={compInfoPanNo}
                              onChange={(e) =>
                                this.setState({
                                  compInfoPanNo: e.target.value,
                                  compInfoPanNoErr: "",
                                })
                              }
                              onInput={toInputUppercase}
                            />
                            <span className="text-danger text-start text-left d-block mt-1">
                              {compInfoPanNoErr}
                            </span>
                          </div>
                          <div className="col-xl-3 mb-1">
                            <label htmlFor="validationCustom01">TAN </label>
                            <input
                              type="text"
                              maxLength={10}
                              className="form-control"
                              value={compInfoTAN}
                              onChange={(e) =>
                                this.setState({
                                  compInfoTAN: e.target.value,
                                  compInfoTANErr: "",
                                })
                              }
                              onInput={toInputUppercase}
                            />
                            <span className="text-danger text-start text-left d-block mt-1">
                              {compInfoTANErr}
                            </span>
                          </div>
                          <div className="col-xl-3 mb-1">
                            <label htmlFor="validationCustom01">GST No </label>
                            <input
                              type="text"
                              maxLength={20}
                              className="form-control"
                              value={compInfoGstNo}
                              onChange={(e) =>
                                this.setState({
                                  compInfoGstNo: e.target.value,
                                  compInfoGstNoErr: "",
                                })
                              }
                              onInput={toInputUppercase}
                            />
                            <span className="text-danger text-start text-left d-block mt-1">
                              {compInfoGstNoErr}
                            </span>
                          </div>
                        </div>
                        <div className="form-row ">
                          <div className="col-xl-3 mb-1">
                            <label htmlFor="validationCustom01">
                              Company Registration No
                            </label>
                            <input
                              type="text"
                              maxLength={21}
                              className="form-control"
                              value={compInfoRegistrationNo}
                              onChange={(e) =>
                                this.setState({
                                  compInfoRegistrationNo: e.target.value,
                                  compInfoRegistrationNoErr: "",
                                })
                              }
                              onInput={toInputUppercase}
                            />
                            {/* <span className='text-danger text-start text-left d-block mt-1'>{compInfoRegistrationNoErr}</span> */}
                          </div>
                          <div className="col-xl-3 mb-1">
                            <label htmlFor="validationCustom01">
                              {" "}
                              IEC Code
                            </label>
                            <input
                              type="text"
                              maxLength={10}
                              className="form-control"
                              value={compInfoIecCode}
                              onChange={(e) =>
                                this.setState({
                                  compInfoIecCode: e.target.value,
                                })
                              }
                              onInput={toInputUppercase}
                            />
                          </div>
                        </div>
                        <h6 className="section-title mb-1 mt-3 fw-semibold">Company Profile</h6>
                        <div className="form-row ">
                          <div className="col-xl-3 mb-1">
                            <label htmlFor="validationCustom01">
                              Year of Establishment{" "}
                              {isVendor && (
                                <span className="text-danger">*</span>
                              )}
                            </label>
                            <input
                              type="text"
                              maxLength={4}
                              className="form-control"
                              value={YearOfEstablishment}
                              onChange={(e) => {
                                let val = e.target.value.replace(/\D/g, "");
                                const currentYear = moment().year();
                                if (val.length === 4) {
                                  if (val < 1950 || val > currentYear) {
                                    this.setState({
                                      YearOfEstablishment: "",
                                      YearOfEstablishmentErr:
                                        `Year must be between 1950 and ${currentYear}`,
                                    });
                                    return;
                                  }
                                }
                                this.setState({
                                  YearOfEstablishment: val,
                                  YearOfEstablishmentErr: "",
                                });
                              }}
                            />
                            {
                              <span className="text-danger text-start text-left d-block mt-1">
                                {this.state.YearOfEstablishmentErr}
                              </span>
                            }
                          </div>
                          <div className="col-xl-3 mb-1">
                            <label htmlFor="validationCustom01">
                              No. of Staff{" "}
                              {isVendor && (
                                <span className="text-danger">*</span>
                              )}
                            </label>
                            <input
                              type="text"
                              maxLength={7}
                              className="form-control"
                              value={NoOfStaff}
                              onChange={(e) =>
                                this.setState({
                                  NoOfStaff: e.target.value.replace(/\D/g, ""),
                                  NoOfStaffErr: "",
                                })
                              }
                            />
                            {
                              <span className="text-danger text-start text-left d-block mt-1">
                                {this.state.NoOfStaffErr}
                              </span>
                            }
                          </div>
                          <div className="col-xl-3 mb-1">
                            <label htmlFor="validationCustom01">
                              No. of Event Handled{" "}
                              {isVendor && (
                                <span className="text-danger">*</span>
                              )}
                            </label>
                            <input
                              type="text"
                              maxLength={5}
                              className="form-control"
                              value={NoOfEventHandled}
                              onChange={(e) =>
                                this.setState({
                                  NoOfEventHandled: e.target.value.replace(
                                    /\D/g,
                                    ""
                                  ),
                                  NoOfEventHandledErr: "",
                                })
                              }
                            />
                            {
                              <span className="text-danger text-start text-left d-block mt-1">
                                {this.state.NoOfEventHandledErr}
                              </span>
                            }
                          </div>
                          <div className="col-xl-12 mb-1">
                            <label htmlFor="validationCustom01">
                              Short Description{" "}
                              {isVendor && (
                                <span className="text-danger">*</span>
                              )}
                            </label>
                            <textarea
                              type="text"
                              maxLength={2000}
                              rows={5}
                              className="form-control"
                              value={ShortDescription}
                              onChange={(e) =>
                                this.setState({
                                  ShortDescription: e.target.value,
                                  ShortDescriptionErr: "",
                                })
                              }
                            />
                            {
                              <span className="text-danger text-start text-left d-block mt-1">
                                {this.state.ShortDescriptionErr}
                              </span>
                            }
                          </div>
                          <div className="col-xl-6 mb-1">
                            <label htmlFor="validationCustom01">
                              USP{" "}
                              {isVendor && (
                                <span className="text-danger">*</span>
                              )}
                            </label>
                            <textarea
                              type="text"
                              maxLength={2000}
                              rows={5}
                              className="form-control"
                              value={USP}
                              onChange={(e) =>
                                this.setState({
                                  USP: e.target.value,
                                  USPErr: "",
                                })
                              }
                            />
                            {
                              <span className="text-danger text-start text-left d-block mt-1">
                                {this.state.USPErr}
                              </span>
                            }
                          </div>
                          <div className="col-xl-6 mb-1">
                            <label htmlFor="validationCustom01">
                              Client List/ Event List{" "}
                              {isVendor && (
                                <span className="text-danger">*</span>
                              )}
                            </label>
                            <textarea
                              type="text"
                              maxLength={2000}
                              rows={5}
                              className="form-control"
                              value={ClientEventList}
                              onChange={(e) =>
                                this.setState({
                                  ClientEventList: e.target.value,
                                  ClientEventListErr: "",
                                })
                              }
                            />
                            {
                              <span className="text-danger text-start text-left d-block mt-1">
                                {this.state.ClientEventListErr}
                              </span>
                            }
                          </div>
                          <div className="form-row mt-3 m-0">
                            <div className="col-xl-12 mb-1">
                              <div className="form-check">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="addDDDetails"
                                  checked={this.state.showDDDetails}
                                  onChange={(e) => {
                                    const checked = e.target.checked;
                                    if (checked && !this.state.DD_SubmittedBy_CompanyName) {
                                      const loginDataSS = JSON.parse(sessionStorage.getItem('loginDataSS') || '{}');
                                      const userEmailSS = sessionStorage.getItem('userEmailSS');
                                      this.setState({
                                        showDDDetails: checked,
                                        DD_SubmittedBy_CompanyName: loginDataSS.CompanyName || '',
                                        DD_SubmittedBy_PersonName: loginDataSS.FirstName || '',
                                        DD_SubmittedBy_EmailId: userEmailSS || '',
                                      });
                                    } else {
                                      this.setState({ showDDDetails: checked });
                                    }
                                  }}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="addDDDetails"
                                >
                                  Add DD Details (If applicable only)
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                        {this.state.showDDDetails && (
                          <>
                            <h6 className="section-title mb-0 fw-semibold">DD Details</h6>
                            <div className="form-row">
                              <div className="col-xl-3 mb-1">
                                <label>
                                  DD Number{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  maxLength={50}
                                  value={this.state.DD_Number}
                                  onChange={(e) =>
                                    this.setState({ DD_Number: e.target.value })
                                  }
                                />
                              </div>
                              <div className="col-xl-3 mb-1">
                                <label>
                                  DD Amount{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  maxLength={10}
                                  value={this.state.DD_Amount}
                                  onChange={(e) =>
                                    this.setState({
                                      DD_Amount: e.target.value.replace(
                                        /\D/g,
                                        ""
                                      ),
                                    })
                                  }
                                />
                              </div>
                              <div className="col-xl-3 mb-1">
                                <label>
                                  DD Date <span className="text-danger">*</span>
                                </label>
                                <DatePicker
                                  className="form-control"
                                  dateFormat="dd-MM-yyyy"
                                  selected={this.state.DD_Date}
                                  onChange={(date) =>
                                    this.setState({ DD_Date: date })
                                  }
                                />
                              </div>
                              <div className="col-xl-3 mb-1">
                                <label>
                                  Bank Name{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  maxLength={100}
                                  value={this.state.DD_BankName}
                                  onChange={(e) =>
                                    this.setState({
                                      DD_BankName: e.target.value,
                                    })
                                  }
                                />
                              </div>
                            </div>
                            <h6 className="section-title mb-0 mt-3 fw-semibold">
                              DD Submitted By
                            </h6>
                            <div className="form-row">
                              <div className="col-xl-3 mb-1">
                                <label>
                                  Company Name{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  maxLength={150}
                                  value={this.state.DD_SubmittedBy_CompanyName}
                                  onChange={(e) =>
                                    this.setState({
                                      DD_SubmittedBy_CompanyName:
                                        e.target.value,
                                      ...(this.state.DD_SameAsAbove && {
                                        DD_ReturnTo_CompanyName: e.target.value,
                                      }),
                                    })
                                  }
                                />
                              </div>
                              <div className="col-xl-3 mb-1">
                                <label>
                                  Person Name{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  maxLength={100}
                                  value={this.state.DD_SubmittedBy_PersonName}
                                  onChange={(e) =>
                                    this.setState({
                                      DD_SubmittedBy_PersonName: e.target.value,
                                      ...(this.state.DD_SameAsAbove && {
                                        DD_ReturnTo_PersonName: e.target.value,
                                      }),
                                    })
                                  }
                                />
                              </div>
                              <div className="col-xl-3 mb-1">
                                <label>
                                  Mobile No.{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  maxLength={20}
                                  value={this.state.DD_SubmittedBy_MobileNo}
                                  onChange={(e) => {
                                    const value = e.target.value.replace(
                                      /\D/g,
                                      ""
                                    );
                                    this.setState({
                                      DD_SubmittedBy_MobileNo: value,
                                      ...(this.state.DD_SameAsAbove && {
                                        DD_ReturnTo_MobileNo: value,
                                      }),
                                    });
                                  }}
                                />
                              </div>
                              <div className="col-xl-3 mb-1">
                                <label>
                                  Email Id.{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="email"
                                  className="form-control"
                                  maxLength={100}
                                  value={this.state.DD_SubmittedBy_EmailId}
                                  onChange={(e) =>
                                    this.setState({
                                      DD_SubmittedBy_EmailId: e.target.value,
                                      ...(this.state.DD_SameAsAbove && {
                                        DD_ReturnTo_EmailId: e.target.value,
                                      }),
                                    })
                                  }
                                />
                              </div>
                            </div>
                            <div className="form-row mt-3 m-0">
                              <div className="col-xl-12 mb-1">
                                <div className="form-check">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="sameAsAbove"
                                    checked={this.state.DD_SameAsAbove}
                                    onChange={(e) => {
                                      const checked = e.target.checked;
                                      this.setState({
                                        DD_SameAsAbove: checked,
                                        DD_ReturnTo_CompanyName: checked
                                          ? this.state
                                            .DD_SubmittedBy_CompanyName
                                          : "",
                                        DD_ReturnTo_PersonName: checked
                                          ? this.state.DD_SubmittedBy_PersonName
                                          : "",
                                        DD_ReturnTo_MobileNo: checked
                                          ? this.state.DD_SubmittedBy_MobileNo
                                          : "",
                                        DD_ReturnTo_EmailId: checked
                                          ? this.state.DD_SubmittedBy_EmailId
                                          : "",
                                      });
                                    }}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="sameAsAbove"
                                  >
                                    Same as above
                                  </label>
                                </div>
                              </div>
                            </div>
                            <h6 className="section-title mb-0 mt-3 fw-semibold">
                              DD Return To
                            </h6>
                            <div className="form-row">
                              <div className="col-xl-3 mb-1">
                                <label>
                                  Company Name{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  maxLength={150}
                                  value={this.state.DD_ReturnTo_CompanyName}
                                  onChange={(e) =>
                                    this.setState({
                                      DD_ReturnTo_CompanyName: e.target.value,
                                    })
                                  }
                                />
                              </div>
                              <div className="col-xl-3 mb-1">
                                <label>
                                  Person Name{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  maxLength={100}
                                  value={this.state.DD_ReturnTo_PersonName}
                                  onChange={(e) =>
                                    this.setState({
                                      DD_ReturnTo_PersonName: e.target.value,
                                    })
                                  }
                                />
                              </div>
                              <div className="col-xl-3 mb-1">
                                <label>
                                  Mobile No.{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  maxLength={20}
                                  value={this.state.DD_ReturnTo_MobileNo}
                                  onChange={(e) =>
                                    this.setState({
                                      DD_ReturnTo_MobileNo:
                                        e.target.value.replace(/\D/g, ""),
                                    })
                                  }
                                />
                              </div>
                              <div className="col-xl-3 mb-1">
                                <label>
                                  Email Id.{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="email"
                                  className="form-control"
                                  maxLength={100}
                                  value={this.state.DD_ReturnTo_EmailId}
                                  onChange={(e) =>
                                    this.setState({
                                      DD_ReturnTo_EmailId: e.target.value,
                                    })
                                  }
                                />
                              </div>
                            </div>
                            <div className="form-row">
                              <div className="col-xl-12 mb-1">
                                <label
                                  className="d-flex align-items-center gap-2 pt-3 pb-2"
                                  style={{ whiteSpace: "nowrap" }}
                                >
                                  <span>
                                    Documents{" "}
                                    <span className="text-danger">*</span>
                                  </span>

                                  <span className="fw-bold text-muted">
                                    Photo ID{" "}
                                    <small>
                                      (Government Approved Document)
                                    </small>
                                  </span>

                                  <span
                                    className="text-danger">
                                    Max 5MB | Pdf, Jpeg, Jpg, Png only
                                  </span>
                                </label>

                                {this.state.DD_FileName ? (
                                  <div
                                    className="d-flex"
                                    style={{ justifyContent: "left" }}
                                  >
                                    <div className="chooseStallFile m-0">
                                      <p
                                        className="overflow-membership m-0"
                                        onClick={() => {
                                          const filePath =
                                            this.state.DD_FilePath;
                                          if (
                                            filePath &&
                                            filePath.startsWith("/document/")
                                          ) {
                                            window.open(
                                              `${BASE_URL}${filePath}`,
                                              "_blank"
                                            );
                                          } else {
                                            this.handleViewFile(
                                              filePath,
                                              this.state.DD_FileName
                                            );
                                          }
                                        }}
                                        style={{ cursor: "pointer" }}
                                      >
                                        {this.state.DD_FileName}
                                      </p>
                                      <span
                                        className="membership_file_cross text-danger"
                                        onClick={() =>
                                          this.setState({
                                            DD_FileName: null,
                                            DD_FilePath: null,
                                            DD_FileType: null,
                                          })
                                        }
                                      >
                                        X
                                      </span>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="d-flex align-items-center">
                                    <button
                                      className="btn btn-aqua"
                                      onClick={() =>
                                        this.setState({ isImageModal: true })
                                      }
                                    >
                                      <i className="bi bi-camera"></i> Open
                                      Camera
                                    </button>
                                    <span className="mx-2 text-muted">or</span>
                                    <input
                                      type="file"
                                      className="w-auto border p-0 rounded-right" style={{ height: '34px !important' }}
                                      onChange={(e) =>
                                        this.onFilePick(e, e.target.files)
                                      }
                                      accept=".jpg,.jpeg,.png,.pdf"
                                    />
                                  </div>
                                )}
                              </div>
                            </div>

                            {/* Add Subcontractor Button */}
                            {/* <div className="mb-2 mt-3">
                            <button
                              type="button"
                              className="btn btn-aqua p-1"
                              onClick={() => {
                                this.setState({
                                  DD_SubContractorList: [
                                    ...this.state.DD_SubContractorList,
                                    {
                                      CompanyName: "",
                                      PersonName: "",
                                      EmailId: "",
                                      MobileNo: "",
                                    },
                                  ],
                                });
                              }}
                            >
                              <i className="ri-add-line me-1" /> Add
                              Subcontractor
                            </button>
                          </div> */}

                            {/* Subcontractor Table */}
                            {/* <div className="table-responsive">
                            <table className="table table-bordered table-striped">
                              <thead className="table-light">
                                <tr>
                                  <th>Company Name</th>
                                  <th>Person Name</th>
                                  <th>Email</th>
                                  <th>Mobile No</th>
                                  <th className="text-center">Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.state.DD_SubContractorList.length > 0 ? (
                                  this.state.DD_SubContractorList.map(
                                    (item, index) => (
                                      <tr key={index}>
                                        <td>
                                          <input
                                            type="text"
                                            value={item.CompanyName}
                                            maxLength={100}
                                            className="form-control"
                                            onChange={(e) => {
                                              const updated = [
                                                ...this.state
                                                  .DD_SubContractorList,
                                              ];
                                              updated[index].CompanyName =
                                                e.target.value;
                                              this.setState({
                                                DD_SubContractorList: updated,
                                              });
                                            }}
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="text"
                                            value={item.PersonName}
                                            maxLength={100}
                                            className="form-control"
                                            onChange={(e) => {
                                              const updated = [
                                                ...this.state
                                                  .DD_SubContractorList,
                                              ];
                                              updated[index].PersonName =
                                                e.target.value;
                                              this.setState({
                                                DD_SubContractorList: updated,
                                              });
                                            }}
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="text"
                                            value={item.EmailId}
                                            maxLength={100}
                                            className="form-control"
                                            onChange={(e) => {
                                              const updated = [
                                                ...this.state
                                                  .DD_SubContractorList,
                                              ];
                                              updated[index].EmailId =
                                                e.target.value;
                                              this.setState({
                                                DD_SubContractorList: updated,
                                              });
                                            }}
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="text"
                                            value={item.MobileNo}
                                            maxLength={10}
                                            className="form-control"
                                            onChange={(e) => {
                                              const updated = [
                                                ...this.state
                                                  .DD_SubContractorList,
                                              ];
                                              updated[index].MobileNo =
                                                e.target.value.replace(
                                                  /\D/g,
                                                  ""
                                                );
                                              this.setState({
                                                DD_SubContractorList: updated,
                                              });
                                            }}
                                          />
                                        </td>
                                        <td className="text-center">
                                          <i
                                            className="fa fa-trash text-danger"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => {
                                              const updated =
                                                this.state.DD_SubContractorList.filter(
                                                  (_, i) => i !== index
                                                );
                                              this.setState({
                                                DD_SubContractorList: updated,
                                              });
                                            }}
                                          />
                                        </td>
                                      </tr>
                                    )
                                  )
                                ) : (
                                  <tr>
                                    <td colSpan={5} className="text-center">
                                      Record not found
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div> */}
                          </>
                        )}
                      </div>
                    </div>
                    <ImageCapture
                      isOpen={this.state.isImageModal}
                      onClose={() => this.setState({ isImageModal: false })}
                      onCapture={(imageData) => {
                        this.setState({
                          DD_FileName: "Document",
                          DD_FileType: "jpeg",
                          DD_FilePath: imageData,
                          isImageModal: false,
                        });
                      }}
                    />
                    <div className="main-container bg-light mt-2">
                      <div className="container-fluid py-1 pb-3 px-2 border">
                        <h6 className="section-title mb-1 mt-2 fw-semibold">Bank Details</h6>
                        <div className="form-row">
                          <div className="col-xl-3 mb-1">
                            <label htmlFor="validationCustom01">
                              Account Name
                            </label>
                            <input
                              type="text"
                              maxLength={100}
                              className="form-control"
                              value={bankDtlAccountName}
                              onChange={(e) =>
                                this.setState({
                                  bankDtlAccountName: e.target.value
                                    .replace(/[^a-zA-Z ]/g, "")
                                    .split(" ")
                                    .map(
                                      (word) =>
                                        word.charAt(0).toUpperCase() +
                                        word.slice(1)
                                    )
                                    .join(" "),
                                  bankDtlAccountNameErr: "",
                                })
                              }
                            />
                            {
                              <span className="text-danger text-start text-left d-block mt-1">
                                {bankDtlAccountNameErr}
                              </span>
                            }
                          </div>
                          <div className="col-xl-3 mb-1">
                            <label htmlFor="validationCustom01">
                              {" "}
                              Account No
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              maxLength={30}
                              onInput={(e) => this.maxLengthCheck(e, 30)}
                              value={bankDtlAccountNo}
                              onChange={(e) =>
                                this.setState({
                                  bankDtlAccountNo: e.target.value.replace(
                                    /\D/,
                                    ""
                                  ),
                                  bankDtlAccountNoErr: "",
                                })
                              }
                            />
                            {
                              <span className="text-danger text-start text-left d-block mt-1">
                                {bankDtlAccountNoErr}
                              </span>
                            }
                          </div>
                          <div className="col-xl-3 mb-1">
                            <label htmlFor="validationCustom01">
                              Account Type
                            </label>
                            <select
                              className="form-control"
                              id="roledb"
                              style={{ textAlign: "left" }}
                              value={bankDtlAccountType}
                              onChange={(e) =>
                                this.setState({
                                  bankDtlAccountType: e.target.value,
                                  bankDtlAccountTypeErr: "",
                                })
                              }
                            >
                              <option>Select</option>
                              <option value={"Savingaccount"}>
                                Saving account
                              </option>
                              <option value={"Currentaccount"}>
                                Current account
                              </option>
                              <option value={"Overdraftaccount"}>
                                Overdraft account
                              </option>
                              <option value={"Others"}>Others</option>
                            </select>
                            {
                              <span className="text-danger text-start text-left d-block mt-1">
                                {bankDtlAccountTypeErr}
                              </span>
                            }
                          </div>
                          <div className="col-xl-3 mb-1">
                            {bankDtlAccountType == "Others" ? (
                              <>
                                <label htmlFor="validationCustom01">
                                  &nbsp;
                                </label>
                                <input
                                  type="text"
                                  maxLength={20}
                                  className="form-control"
                                  value={bankDtlAccountTypeOthers}
                                  onChange={(e) =>
                                    this.setState({
                                      bankDtlAccountTypeOthers: e.target.value,
                                      bankDtlAccountTypeOthersErr: "",
                                    })
                                  }
                                />
                                {
                                  <span className="text-danger text-start text-left d-block mt-1">
                                    {bankDtlAccountTypeOthersErr}
                                  </span>
                                }
                              </>
                            ) : null}
                          </div>
                        </div>
                        <div className="form-row ">
                          <div className="col-xl-3 mb-1">
                            <label htmlFor="validationCustom01">
                              Bank Name
                            </label>
                            <input
                              type="text"
                              maxLength={100}
                              className="form-control"
                              value={bankDtlBankName}
                              onChange={(e) =>
                                this.setState({
                                  bankDtlBankName: e.target.value
                                    .replace(/[^a-zA-Z ]/g, "")
                                    .split(" ")
                                    .map(
                                      (word) =>
                                        word.charAt(0).toUpperCase() +
                                        word.slice(1)
                                    )
                                    .join(" "),
                                })
                              }
                            />
                          </div>
                          <div className="col-xl-3 mb-1">
                            <label htmlFor="validationCustom01">
                              Branch Name
                            </label>
                            <input
                              type="text"
                              maxLength={50}
                              className="form-control"
                              value={bankDtlBranchName}
                              onChange={(e) =>
                                this.setState({
                                  bankDtlBranchName: e.target.value
                                    .replace(/[^a-zA-Z ]/g, "")
                                    .split(" ")
                                    .map(
                                      (word) =>
                                        word.charAt(0).toUpperCase() +
                                        word.slice(1)
                                    )
                                    .join(" "),
                                })
                              }
                            />
                          </div>
                          <div className="col-xl-3 mb-1">
                            <label htmlFor="validationCustom01">
                              {" "}
                              IFSC CODE{" "}
                            </label>
                            <input
                              type="text"
                              maxLength={50}
                              className="form-control"
                              value={bankDtlIfscCode}
                              onChange={(e) =>
                                this.setState({
                                  bankDtlIfscCode: e.target.value,
                                  bankDtlIfscCodeErr: "",
                                })
                              }
                              onInput={toInputUppercase}
                            />
                            {
                              <span className="text-danger text-start text-left d-block mt-1">
                                {bankDtlIfscCodeErr}
                              </span>
                            }
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="main-container bg-light mt-2">
                      <div className="container-fluid py-1 pb-3 px-2 border">
                        <h6 className="section-title mb-2 fw-semibold">
                          {" "}
                          Hall Allocation<span className="text-danger">
                            *
                          </span>{" "}
                        </h6>
                        <div className="row ">
                          {renderHallZoneList.length > 0 ? (
                            renderHallZoneList.map((item, i) => (
                              <div className="col-12 col-lg-6">
                                <div className="table-responsive mt-2">
                                  <h6 className="section-title" style={{ fontSize: '16px' }}>{item.Name}</h6>
                                  <table
                                    className="table table-bordered mb-4"
                                    id="responsibilityTable"
                                  >
                                    <thead className="table-light">
                                      <tr>
                                        <th style={{ width: 180 }}>
                                          <input
                                            type="checkbox"
                                            className=""
                                            checked={item.isAllHallChecked}
                                            disabled={isVendor}
                                            onChange={(e) =>
                                              this.handleAllHallChecked(e, i)
                                            }
                                          />
                                          Hall
                                        </th>
                                        <th className="text-left p-0 px-2">Zone</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {item.HallZoneList
                                        // filter rows based on isVendor
                                        .filter(
                                          (obj) =>
                                            !isVendor || obj.isHallChecked
                                        )
                                        .map((obj, i) => (
                                          <tr key={i}>
                                            <td>
                                              <label className="d-flex">
                                                <input
                                                  type="checkbox"
                                                  className="h-auto mx-1"
                                                  value={obj.isHallChecked}
                                                  checked={obj.isHallChecked}
                                                  disabled={isVendor}
                                                  onChange={(e) =>
                                                    this.handleTableInput(
                                                      e,
                                                      item.Name,
                                                      i,
                                                      "hall",
                                                      ""
                                                    )
                                                  }
                                                />
                                                {obj.HallName}
                                              </label>
                                            </td>

                                            <td className="text-center">
                                              <div
                                                className="d-flex">
                                                <div className="form-check">
                                                  <input
                                                    className="form-check-input radio-all"
                                                    type="radio"
                                                    value={obj.All}
                                                    checked={obj.All}
                                                    disabled={
                                                      !obj.isHallChecked ||
                                                      isVendor
                                                    }
                                                    onChange={(e) =>
                                                      this.handleTableInput(
                                                        e,
                                                        item.Name,
                                                        i,
                                                        "radio",
                                                        "All"
                                                      )
                                                    }
                                                  />
                                                  <label className="form-check-label">
                                                    All
                                                  </label>
                                                </div>

                                                <div className="form-check ml-2">
                                                  <input
                                                    className="form-check-input radio-specific"
                                                    type="radio"
                                                    value={obj.Specific}
                                                    checked={obj.Specific}
                                                    disabled={
                                                      !obj.isHallChecked ||
                                                      isVendor
                                                    }
                                                    onChange={(e) =>
                                                      this.handleTableInput(
                                                        e,
                                                        item.Name,
                                                        i,
                                                        "radio",
                                                        "Specific"
                                                      )
                                                    }
                                                  />
                                                  <label className="form-check-label">
                                                    Specific
                                                  </label>
                                                </div>
                                              </div>

                                              <div
                                                className="d-flex justify-content-start"
                                                data-row={1}
                                                style={{
                                                  rowGap: 0,
                                                  columnGap: 0,
                                                }}
                                              >
                                                {obj.Specific &&
                                                  obj.zonelist.map(
                                                    (data, zoneIndex) => (
                                                      <div
                                                        className="zones"
                                                        style={{
                                                          width: "100%",
                                                        }}
                                                        key={zoneIndex}
                                                      >
                                                        <div className="row m-0">
                                                          <div className="col-md-3 p-0">
                                                            <div className="form-check">
                                                              <input
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                value={
                                                                  data.isZoneCheked
                                                                }
                                                                checked={
                                                                  data.isZoneCheked
                                                                }
                                                                disabled={
                                                                  isVendor
                                                                }
                                                                onChange={(e) =>
                                                                  this.handleTableInput(
                                                                    e,
                                                                    item.Name,
                                                                    i,
                                                                    "zonelist",
                                                                    "Specific",
                                                                    zoneIndex
                                                                  )
                                                                }
                                                              />
                                                              <label className="form-check-label">
                                                                {data.Zone}
                                                              </label>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    )
                                                  )}
                                              </div>
                                            </td>
                                          </tr>
                                        ))}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            ))
                          ) : (
                            <p>Record not found</p>
                          )}
                        </div>
                        <div id="hallCheckboxes" className="row g-3" />
                      </div>
                    </div>

                    <div className="vendor-reg-btn-wrapper">
                      <div className="mt-2 gap-2" style={{ display: "flex", justifyContent: "end" }}>
                        {add ? (
                          <button
                            className="btn btn-aqua px-3 mb-2"
                            style={{ cursor: "pointer" }}
                            onClick={(e) => this.setState({ isOpen2: true })}
                          >
                            Save
                          </button>
                        ) : (
                          <>
                            {AccountType === "Enroll" ? (
                              <button
                                className="btn btn-aqua px-3 mb-2"
                                style={{ cursor: "pointer" }}
                                onClick={(e) => this.setState({ isOpen2: true })}
                              >
                                Save
                              </button>
                            ) : (
                              <button
                                className="btn btn-aqua px-3 mb-2"
                                onClick={(e) => this.updateVendor()}
                              >
                                Update
                              </button>
                            )}
                          </>
                        )}

                        <button
                          className="btn btn-gray px-3 mb-2"
                          onClick={(e) => this.cancle()}
                        >
                          Back
                        </button>
                      </div>
                      <div className="vendor-reg-bottom-spacer"></div>
                    </div>

                    {!isVendor && !isWorkUpdation && <Footer />}
                  </div>
                </div>
              </div>
            </div>

            <Modal isOpen={isOpen2} onRequestClose={() => this.setState({ isOpen2: false })}>
              <div className="modal-dialog">
                <div className="modal-content confirm-logout">
                  <div class="modal-header text-right p-2">
                    <h5 class="modal-title modal_title_text">Confirm Email to Vendor!</h5>
                    <button type="button" class="btn-close btn-close-white text-white" onClick={() => this.setState({ isOpen2: false })} ></button>
                  </div>
                  <div class="modal-body">
                    Would you like to send an email to the vendor?
                  </div>
                  <div class="modal-footer p-1">
                    <div class="form-group text-right mod-fot">
                      <button type="button" class="btn btn-aqua mx-2"
                        onClick={(e) => this.addVendor(true)}
                      >Yes</button>
                      <button type="button" class="btn btn-aqua" data-dismiss="modal"
                        onClick={(e) => this.addVendor(false)}
                      >No</button>
                    </div>
                  </div>

                </div>
              </div>
            </Modal>

            {/* </div> */}
          </>
        </div>
      </>
    );
  }
}

export default withRouter(
  connect(null, {
    fill_action, getAPDetails_action,
    insertUpdateAP_action,
    addVendorRegistration_action,
    updateVendorRegistration_action,
    getDetailsVendorRegistration_action,
  })(VendorRegistrationAU)
);
